(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "react", "lodash", "prop-types", "@fiverr/i18n/singleton", "@fiverr/gofor", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SharingLink"] = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else
		root["SharingLink"] = factory(root["classNames"], root["React"], root["_"], root["PropTypes"], root["i18n"], root["goforFactory"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_JgyH__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_jPm4__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr-private/sharing_link/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0Qmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CFU":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__("JgyH"),__webpack_require__("Jmof"),__webpack_require__("T9WB"),__webpack_require__("wLXD")):"function"===typeof define&&define.amd?define(["classnames","react","prop-types","react-dom"],t):"object"===typeof exports?exports.Modal=t(require("classnames"),require("react"),require("prop-types"),require("react-dom")):e.Modal=t(e.classNames,e.React,e.PropTypes,e.ReactDOM)}("undefined"!==typeof self?self:this,function(e,t,n,o){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/modal/",t(t.s="lVK7")}({"2KtJ":function(e,t){},"5BCh":function(e,t,n){!function(t,o){e.exports=o(n("Jmof"))}("undefined"!==typeof self&&self,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/ui_toggle/",t(t.s="lVK7")}({Jmof:function(t,n){t.exports=e},lVK7:function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return"function"===typeof e}Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"CLASS_NO_MODAL_CLICK",function(){return u});var s=n("Jmof"),l=(n.n(s),"function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}),c=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u="modal-no-click",p=function(e){function t(e){o(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.CLASS_NO_MODAL_CLICK=u,n.notPropagatingElements=new Set,n.open=function(){var e=function(){n.setState({isOpen:!0},function(){n.bindClickListener(),a(n.togglerDidOpen)&&n.togglerDidOpen()})};if(a(n.togglerWillOpen)){if(n.togglerWillOpen(e),!n.togglerWillOpen.length)return e()}else e()},n.close=function(){var e=function(){n.setState({isOpen:!1},function(){n.removeClickListener(),a(n.togglerDidClose)&&n.togglerDidClose()})};if(a(n.togglerWillClose)){if(n.togglerWillClose(e),!n.togglerWillClose.length)return e()}else e()},n.toggle=function(){return n.state.isOpen?n.close():n.open()},n.bindClickListener=function(){!1!==n.props.bindBodyClickListener&&document.body.addEventListener("click",n.onBodyClick)},n.removeClickListener=function(){return document.body.removeEventListener("click",n.onBodyClick)},n.shouldPreventPropagationByClassName=function(e){return!(!e||!e.classList)&&e.classList.contains(n.CLASS_NO_MODAL_CLICK)},n.shouldPreventPropagationByElement=function(e){if(!e)return!1;if(!e.contains)return!1;if(!n.notPropagatingElements.size)return!1;if(n.notPropagatingElements.has(e))return!0;var t=!0,o=!1,r=void 0;try{for(var i,a=n.notPropagatingElements[Symbol.iterator]();!(t=(i=a.next()).done);t=!0){var s=i.value;if(s.contains&&s.contains(e))return!0}}catch(e){o=!0,r=e}finally{try{!t&&a.return&&a.return()}finally{if(o)throw r}}return!1},n.preventCloseAction=function(e){if(e)return n.notPropagatingElements.has(e)?null:void n.notPropagatingElements.add(e)},n.onBodyClick=n.onBodyClick.bind(n),n.state={isOpen:e.defaultOpen||!1},n}return i(t,e),c(t,[{key:"componentWillMount",value:function(){this.state.isOpen&&this.bindClickListener()}},{key:"componentWillUnmount",value:function(){this.removeClickListener()}},{key:"onBodyClick",value:function(e){var t=e.target;return this.state.isOpen?a(this.shouldPreventCloseAction)&&!0===this.shouldPreventCloseAction(t)?null:this.shouldPreventPropagationByClassName(t)||this.shouldPreventPropagationByElement(t)?null:void this.close():null}},{key:"render",value:function(){var e=this.props.children,t="undefined"===typeof e?"undefined":l(e);if("undefined"!==t&&"function"!==t)throw new TypeError("Toggler: `children` must be a function");var n=this.close,o=this.open,r=this.toggle,i=this.CLASS_NO_MODAL_CLICK,a=this.preventCloseAction,s=this.state.isOpen,c=this.toggleContent?this.toggleContent:e;return c?c({isOpen:s,close:n,open:o,toggle:r,CLASS_NO_MODAL_CLICK:i,preventCloseAction:a}):null}}]),t}(s.Component);p.defaultProps={defaultOpen:!1},t.default=p}})})},JgyH:function(t,n){t.exports=e},Jmof:function(e,n){e.exports=t},Qwgx:function(e,t){},T9WB:function(e,t){e.exports=n},f2ea:function(e,t){},ixLB:function(e,t){},lVK7:function(e,t,n){"use strict";function o(e){return"function"===typeof e}function r(e,t){return void 0===e||null===e?null:o(e)?e(t):e}function i(e,t){var n={};for(var o in e)t.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function l(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function c(e){var t=e.children,n=e.hasCloseBtn,o=e.close;return y.a.createElement("header",{className:"MODAL__modal-content-header"},y.a.createElement("h2",{className:"MODAL__modal-content-header-body"},t),n&&y.a.createElement(A,{onClick:o}))}function u(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function p(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function f(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var d=n("Jmof"),y=n.n(d),h=n("wLXD"),v=n.n(h),g=n("T9WB"),m=n.n(g),b=n("JgyH"),O=n.n(b),_=n("5BCh"),C=n.n(_),w=(n("zr3G"),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),E=function e(t,n,o){null===t&&(t=Function.prototype);var r=Object.getOwnPropertyDescriptor(t,n);if(void 0===r){var i=Object.getPrototypeOf(t);return null===i?void 0:e(i,n,o)}if("value"in r)return r.value;var a=r.get;if(void 0!==a)return a.call(o)},k=function(e){function t(e){a(this,t);var n=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.__view=n.__view.bind(n),n.draw=n.draw.bind(n),n.onEscape=n.onEscape.bind(n),n}return l(t,e),w(t,[{key:"componentDidUpdate",value:function(){this.draw()}},{key:"componentWillUnmount",value:function(){E(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"componentWillUnmount",this).call(this),this.close()}},{key:"onEscape",value:function(e){27!==e.keyCode&&27!==e.which&&"Escape"!==e.code&&"Escape"!==e.key||this.close()}},{key:"togglerWillOpen",value:function(){this.target||(this.target=document.createElement("div"),this.target.className=this.targetClassName,document.body.appendChild(this.target),this.props.closeOnEscape&&window.addEventListener("keyup",this.onEscape),this.draw())}},{key:"togglerDidOpen",value:function(){var e=this;setTimeout(function(){return e.target.classList.add("shown")},0),o(this.props.onOpen)&&this.props.onOpen()}},{key:"togglerWillClose",value:function(e){var t=this;this.target&&(this.target.classList.remove("shown"),this.target.addEventListener("transitionend",function(){v.a.unmountComponentAtNode(t.target),document.body.removeChild(t.target),t.target=void 0,e()},{once:!0}),window.removeEventListener("keyup",this.onEscape))}},{key:"togglerDidClose",value:function(){o(this.props.onClose)&&this.props.onClose()}},{key:"__view",value:function(e){return this.props.children(e)}},{key:"draw",value:function(){this.target&&v.a.unstable_renderSubtreeIntoContainer(this,this.__view(this.modalProps),this.target)}},{key:"render",value:function(){return r(this.props.trigger,this.modalProps)}},{key:"targetClassName",get:function(){return O()("MODAL__modal",this.props.name)}},{key:"modalProps",get:function(){var e=this.open,t=this.close,n=this.toggle,o=this.preventCloseAction,r=this.state.isOpen,a=this.props,s=(a.trigger,a.children,i(a,["trigger","children"]));return Object.assign({},{open:e,close:t,toggle:n,preventCloseAction:o,isOpen:r},s)}}]),t}(C.a);k.propTypes={onOpen:m.a.func,onClose:m.a.func,closeOnEscape:m.a.bool,bindBodyClickListener:m.a.bool,trigger:m.a.func},k.defaultProps={closeOnEscape:!0,bindBodyClickListener:!0};var P=k,L=(n("m+lv"),function(e){var t=e.children,n=e.preventCloseAction;return e.isOpen?y.a.createElement("div",{className:"MODAL__modal-content",ref:n},t):null});L.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var j=L,x=(n("2KtJ"),function(e){var t=e.onClick;return y.a.createElement("button",{className:"MODAL__modal-content-close",onClick:t},y.a.createElement("span",null,"\xd7"))});x.propTypes={onClick:m.a.func.isRequired};var A=x;n("Qwgx");c.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired},c.defaultProps={hasCloseBtn:!0};var B=c,D=(n("f2ea"),function(e){var t=e.children;return y.a.createElement("section",{className:"MODAL__modal-content-body"},t)});D.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var S=D,T=(n("zvIh"),function(e){var t=e.children;return y.a.createElement("footer",{className:"MODAL__modal-content-footer"},t)});T.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var M=T,N=(n("ixLB"),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),W=function(e){function t(){return u(this,t),p(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return f(t,e),N(t,[{key:"__view",value:function(e){var t=this.props,n=t.header,o=t.footer,i=t.children,a=t.hasCloseBtn;return y.a.createElement(j,e,n&&y.a.createElement(B,{hasCloseBtn:a,close:e.close},r(n,e)),i&&y.a.createElement(S,null,r(i,e)),o&&y.a.createElement(M,null,r(o,e)))}}]),t}(P);W.propTypes={header:m.a.any,footer:m.a.any,children:m.a.any,hasCloseBtn:m.a.bool};var q=W;n.d(t,"Base",function(){return q});t.default=P},"m+lv":function(e,t){},wLXD:function(e,t){e.exports=o},zr3G:function(e,t){},zvIh:function(e,t){}})});
//# sourceMappingURL=index.d131d2f715612f7c3082.js.map

/***/ }),

/***/ "ETja":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eout":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JgyH":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_JgyH__;

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "KRU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NPIf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nv6r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ojd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbPb":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_PbPb__;

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "Z45/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dHXs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"sharing_link":{"medium":{"facebook":"Facebook","twitter":"Twitter","linkedin":"LinkedIn","whatsapp":"WhatsApp","fb_messenger":"Messenger","copy_link":"Copy Link","email":"Email","embed":"Embed","visited":{"copy_link":"Link Copied"}},"invite":{"input":"Enter email addresses, separated by commas","send_to":"Send to","textarea":{"caption":"Personal message"}},"button":{"share":"Share","send":"Send Email"}},"general":{"share":"Share"},"sources":{"defaults":{"title":"General Sharing Title","email_title":"Share by mail","description":["General Sharing Description 1","General Sharing Description 2"],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link"],"share_texts":{"default":"Check out this page!","twitter":"Check out this page!"}},"gigs_show":{"default":{"title":"Boost Your Traffic","email_title":"Share this Gig","description":["Share your Gig to grow your audience","engage with potential buyers and earn more trust."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link"],"share_texts":{"default":"Check it out! #MadeOnFiverr","twitter":"Check out my Gig on Fiverr: %{gig_title}"}}},"manage_gigs":{"default":{"title":"Boost Your Traffic","email_title":"Share this Gig","description":["Share your Gig to grow your audience","engage with potential buyers and earn more trust."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link"],"share_texts":{"default":"Check it out! #MadeOnFiverr","twitter":"Check out my Gig on Fiverr: %{gig_title}"}}},"gigs_show_buyers":{"default":{"title":"Share This Gig","email_title":"Share this Gig","description":["Spread the word about this Gig on Fiverr"],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link"],"share_texts":{"default":"Check it out! #MadeOnFiverr","twitter":"Check it out! #MadeOnFiverr: %{gig_title}"}}},"delivery":{"default":{"title":"Share your results","email_title":"Share this Gig","description":["Share your Delivery to get your friends excited","let them give you some feedback on your work."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link"],"share_texts":{"default":"Check out this delivery!","twitter":"Check out my delivery on Fiverr"}}},"test":{"1234":{"1":{"title":"Boost Your Traffic variation 1","email_title":"Share this Gig","description":["Share your Gig to grow your audience","engage with potential buyers and earn more trust."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link","email"],"share_texts":{"default":"Check out this gig!","twitter":"Check out my Gig on Fiverr: %{gig_title}"}},"2":{"title":"Boost Your Traffic variation 2","email_title":"Share this Gig","description":["Share your Gig to grow your audience","engage with potential buyers and earn more trust."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link","email"],"share_texts":{"default":"Check out this gig!","twitter":"Check out my Gig on Fiverr: %{gig_title}"}}},"default":{"title":"Boost Your Traffic","email_title":"Share this Gig","description":["Share your Gig to grow your audience","engage with potential buyers and earn more trust."],"mediums":["facebook","linkedin","twitter","whatsapp","copy_link","email"],"share_texts":{"default":"Check out this gig!","twitter":"Check out my Gig on Fiverr: %{gig_title}"}}}}}

/***/ }),

/***/ "h4G9":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_h4G9__;

/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jPm4":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_jPm4__;

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/pluck/index.mjs
/**
 * @module pluck
 * @since 1.0.0
 */

/**
 * Pluck values of a certain key from array of objects
 *
 * @param  {Object[]}  objects Array of objects
 * @param  {String} key The key we want to pluck
 * @return {Array}  An array of the values stored in the specified key of each object
 *
 * @example pluck([{key_name: 1}, {key_name: 2}], 'key_name');
 * // [1, 2]
 */
var pluck = function pluck() {
  var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments[1];
  return objects.map(function (item) {
    return item[key];
  });
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/shuffle/index.mjs
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module shuffle
 * @since 1.0.0
 */

/**
 * Shuffle array
 *
 * @param  {Array}  array - An array
 * @param  {Boolean|true} mutate - whether to mutate the original array
 * @return {Array} The shuffled array
 *
 * @example
 * shuffle([1, 2, 3], false);
 * // [1, 3, 2] for example
 */
function shuffle() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var mutate = arguments[1];

    if (!Array.isArray(array)) {
        throw new TypeError("shuffle expects first argument to be an array, got a " + (typeof array === "undefined" ? "undefined" : _typeof(array)));
    }

    var index = array.length;

    // Don't mutate the original array
    if (mutate === false) {
        array = array.slice(0);
    }

    while (index) {
        var curry = Math.floor(Math.random() * index);
        var item = array[--index];
        array[index] = array[curry];
        array[curry] = item;
    }

    return array;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/index.mjs
/**
 * @namespace array
 * @since 2.0.0
 */




/**
 * array A collection of array related methods
 * @type     {Object}
 * @property {Function} pluck   @see <a href="identifiers.html#array-pluck">pluck</a>
 * @property {Function} shuffle @see <a href="identifiers.html#array-shuffle">shuffle</a>
 */
var array = {
  pluck: pluck,
  shuffle: shuffle
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/MINUTE_IN_MS/index.mjs
/**
 * How many milliseconds are in a minute
 * @type {Number}
 */
var MINUTE_IN_MS = 6e4;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/HOUR_IN_MS/index.mjs
/**
 * How many milliseconds are in an hour
 * @type {Number}
 */
var HOUR_IN_MS = 36e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/DAY_IN_MS/index.mjs
/**
 * How many milliseconds are in a day
 * @type {Number}
 */
var DAY_IN_MS = 864e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/WEEK_IN_MS/index.mjs
/**
 * How many milliseconds are in a week
 * @type {Number}
 */
var WEEK_IN_MS = 6048e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/MONTH_IN_MS/index.mjs
/**
 * How many milliseconds are in a month
 * @type {Number}
 */
var MONTH_IN_MS = 2592e6;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/YEAR_IN_MS/index.mjs
/**
 * How many milliseconds are in a year
 * @type {Number}
 */
var YEAR_IN_MS = 31536e6;
// EXTERNAL MODULE: external {"commonjs":"@fiverr/i18n/singleton","commonjs2":"@fiverr/i18n/singleton","amd":"@fiverr/i18n/singleton","root":"i18n","var":"i18n"}
var singleton___root___i18n___var___i18n__ = __webpack_require__("h4G9");
var singleton___root___i18n___var___i18n___default = /*#__PURE__*/__webpack_require__.n(singleton___root___i18n___var___i18n__);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/howLongAgo/index.mjs
/**
 * @module howLongAgo
 * @since 2.0.0
 */





/**
 * Default translation prefix
 * @type {String}
 */
var DEFAULT_PREFIX = 'general.how_long_ago.';

/**
 * return the time that has passed since the current time
 * @param  {Date|Number|String} date Point in time to describe in words. Ticks can be accepted as a number or string
 * @param  {Object} options
 * @param  {String} [options.prefix='general.how_long_ago.'] The base string for the translation
 * @return {String}                                          Descriptive, relative time
 *
 * @property {Number} MINUTE_IN_MS Number of milliseconds in a minute
 * @property {Number} HOUR_IN_MS   Number of milliseconds in an hour
 * @property {Number} DAY_IN_MS    Number of milliseconds in a day
 * @property {Number} WEEK_IN_MS   Number of milliseconds in a week
 * @property {Number} MONTH_IN_MS  Number of milliseconds in a month
 * @property {Number} YEAR_IN_MS   Number of milliseconds in a year
 */
function howLongAgo() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === undefined ? DEFAULT_PREFIX : _ref$prefix;

  var now = Date.now();
  var t = now - date;

  /* eslint-disable no-multi-spaces */
  return Number.isNaN(t) ? '' : // invalid
  t < MINUTE_IN_MS && howLongAgo_txt(prefix, 'just_now') || // seconds
  t < HOUR_IN_MS && howLongAgo_txt(prefix, 'minutes_ago', t / MINUTE_IN_MS) || // minutes
  t < DAY_IN_MS && howLongAgo_txt(prefix, 'hours_ago', t / HOUR_IN_MS) || // hours
  t < WEEK_IN_MS && howLongAgo_txt(prefix, 'days_ago', t / DAY_IN_MS) || // days
  t < MONTH_IN_MS && howLongAgo_txt(prefix, 'weeks_ago', t / WEEK_IN_MS) || // weeks
  t < YEAR_IN_MS && howLongAgo_txt(prefix, 'months_ago', t / MONTH_IN_MS) || // months
  howLongAgo_txt(prefix, 'years_ago', t / YEAR_IN_MS); // years
  /* eslint-enable no-multi-spaces */
}

/**
 * Translate how long ago X
 * @private
 * @param  {String} prefix translation root (with trailing dot where applicable)
 * @param  {String} k      translation key
 * @param  {Number} [c=0]  count
 * @return {String}
 */
var howLongAgo_txt = function txt(prefix, k) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return singleton___root___i18n___var___i18n___default.a.t('' + prefix + k, { count: Math.floor(c) });
};

// Assign used consts to the function
Object.assign(howLongAgo, {
  MINUTE_IN_MS: MINUTE_IN_MS,
  HOUR_IN_MS: HOUR_IN_MS,
  DAY_IN_MS: DAY_IN_MS,
  WEEK_IN_MS: WEEK_IN_MS,
  MONTH_IN_MS: MONTH_IN_MS,
  YEAR_IN_MS: YEAR_IN_MS
});
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/setTime/index.mjs
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var setTime__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module datetime/setTime
 * @since 2.0.0
 */

/**
 * setTime - get a date according to provided time
 * @param  {Date}   date
 * @param  {String} time time string with the format of HH:MM:SS, units are omittable
 * @return {Date}
 *
 * @example setTime((new Date()), '10:30');
 */
function setTime(date, time) {
  if (typeof time !== 'string') {
    throw new TypeError('setTime expects "time" argument to be a string. Instead got a ' + (typeof string === 'undefined' ? 'undefined' : setTime__typeof(string)));
  }

  var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 3),
      _time$split2$ = _time$split2[0],
      hours = _time$split2$ === undefined ? 0 : _time$split2$,
      _time$split2$2 = _time$split2[1],
      minutes = _time$split2$2 === undefined ? 0 : _time$split2$2,
      _time$split2$3 = _time$split2[2],
      seconds = _time$split2$3 === undefined ? 0 : _time$split2$3;

  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(parseInt(seconds, 10));
  return date;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/inTimeRange/index.mjs
/**
 * @module datetime/inTimeRange
 * @since 2.0.0
 */



/**
 * inTimeRange - check if the date object provided is in the time range
 * @param  {Date}   date *can also be a date that represent a different timezone
 * @param  {String} from represent a starting time, example: 'HH:MM'
 * @param  {String} to   represent an ending time, example: 'HH:MM'
 * @return {Boolean}
 *
 * @example inTimeRange((new Date()), '10:30', '13:45')
 */
function inTimeRange(date, from, to) {
  var time = date.getTime();

  return setTime(new Date(time), from).getTime() <= time && setTime(new Date(time), to).getTime() >= time;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/remoteDate/index.mjs
/**
 * @module datetime/remoteDate
 * @since 2.0.0
 */



/**
 * getRemote - get a remote date object according to an offset
 * @param  {Number} offset represent the offset from UTC time minutes
 * @return {Date}
 *
 * @example getRemote(remoteOffset);
 */
function remoteDate(offset) {
  var date = new Date();
  var localOffset = date.getTimezoneOffset();
  var localTime = date.getTime();

  var localOffsetMsec = localOffset * MINUTE_IN_MS;
  var remoteOffsetMsec = offset * MINUTE_IN_MS;
  var remoteTime = localTime + localOffsetMsec - remoteOffsetMsec;

  return new Date(remoteTime);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/formatDate/index.mjs
/**
 * @module datetime/formatDate
 * @since 2.4.0
 */

var DEFAULT_YEAR_FORMAT = 'numeric';
var DEFAULT_MONTH_FORMAT = 'short';
var DEFAULT_DAY_FORMAT = 'numeric';
var DEFAULT_LOCALE = 'en';

/**
 * formatDate - get a date string according to formatting options
 * @param   {Date} datetime
 * @param   {Object} options
 * @param   {String} [options.year='numeric']
 * @param   {String} [options.month='short']
 * @param   {String} [options.day='short']
 * @param   {String} [options.locale='en']
 * @returns {String} representation of the date based on formatting options
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
 */
function formatDate(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$year = _ref.year,
      year = _ref$year === undefined ? DEFAULT_YEAR_FORMAT : _ref$year,
      _ref$month = _ref.month,
      month = _ref$month === undefined ? DEFAULT_MONTH_FORMAT : _ref$month,
      _ref$day = _ref.day,
      day = _ref$day === undefined ? DEFAULT_DAY_FORMAT : _ref$day,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? DEFAULT_LOCALE : _ref$locale;

  if (!(date instanceof Date)) {
    throw new TypeError('formatDate expects \'date\' argument to be instance of Date');
  }

  var formatter = new Intl.DateTimeFormat(locale, { month: month, year: year, day: day });
  return formatter.format(date);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/index.mjs
/**
 * @namespace datetime
 * @since 2.0.0
 */













/**
 * datetime A collection of datetime related methods
 * @type     {Object}
 * @property {Number}   MINUTE_IN_MS @see <a href="identifiers.html#array-minute_in_ms">MINUTE_IN_MS</a>
 * @property {Number}   HOUR_IN_MS   @see <a href="identifiers.html#array-hour_in_ms">HOUR_IN_MS</a>
 * @property {Number}   DAY_IN_MS    @see <a href="identifiers.html#array-day_in_ms">DAY_IN_MS</a>
 * @property {Number}   WEEK_IN_MS   @see <a href="identifiers.html#array-week_in_ms">WEEK_IN_MS</a>
 * @property {Number}   MONTH_IN_MS  @see <a href="identifiers.html#array-month_in_ms">MONTH_IN_MS</a>
 * @property {Number}   YEAR_IN_MS   @see <a href="identifiers.html#array-year_in_ms">YEAR_IN_MS</a>
 * @property {Function} setTime      @see <a href="identifiers.html#array-settime">setTime</a>
 * @property {Function} remoteDate   @see <a href="identifiers.html#array-remotedate">remoteDate</a>
 * @property {Function} inTimeRange  @see <a href="identifiers.html#array-intimerange">inTimeRange</a>
 */

var datetime = {
    MINUTE_IN_MS: MINUTE_IN_MS,
    HOUR_IN_MS: HOUR_IN_MS,
    DAY_IN_MS: DAY_IN_MS,
    WEEK_IN_MS: WEEK_IN_MS,
    MONTH_IN_MS: MONTH_IN_MS,
    YEAR_IN_MS: YEAR_IN_MS,
    howLongAgo: howLongAgo,
    inTimeRange: inTimeRange,
    remoteDate: remoteDate,
    setTime: setTime,
    formatDate: formatDate
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/glob/index.mjs
var glob__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module glob
 * @since 2.0.0
 * @description exposes the global object (self | global | window)
 *
 * @example import {glob} from @fiverr/futile
 * if ('fetch' in glob) { ... }
 */
var glob = (typeof window === 'undefined' ? 'undefined' : glob__typeof(window)) === 'object' && window.window === window && window || (typeof GLOBAL === 'undefined' ? 'undefined' : glob__typeof(GLOBAL)) === 'object' && GLOBAL.GLOBAL === GLOBAL && GLOBAL || (typeof self === 'undefined' ? 'undefined' : glob__typeof(self)) === 'object' && self.self === self && self;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/resolve/index.mjs
var resolve__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module resolve
 * @since 1.0.0
 */



/**
 * Resolve dot notation string.
 *
 * @param  {String} string    Dot notation representation
 * @param  {Object} [context] Object to start notation search (defaults to global scope)
 * @return {Any}    Whatever it finds / undefined
 *
 * @example
 * const data_object = {
 *   top_level: {
 *     nested: {
 *       value: 'My Value'
 *     }
 *   }
 * };
 *
 * resolve('top_level.nested.value', data_object);
 * // 'My Value'
 *
 * resolve('top_level.missing.value', data_object);
 * // undefined
 */
var resolve_resolve = function resolve() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : glob;
  return string.split('.').reduce(function (previous, current) {
    return (typeof previous === 'undefined' ? 'undefined' : resolve__typeof(previous)) === 'object' ? previous[current] : previous;
  }, context);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/mixin/memoizer/index.mjs
var memoizer__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module memoizer
 * @private
 * @since 2.0.0
 */

/**
 * @typedef ObjectProperty
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
 * @type     {Object}
 * @property {boolean}  [configurable=true]
 * @property {boolean}  [enumerable=true]
 * @property {boolean}  [writable=true]
 * @property {any}      [value=undefined]
 * @property {function} [get=undefined]
 * @property {function} [set=undefined]
 */

/**
 * OBJECT_PROPERTY_ATTRIBUTES attributes of an ObjectProperty
 * @type {Array}
 */
var OBJECT_PROPERTY_ATTRIBUTES = ['get', 'value', 'set', 'configurable', 'enumerable', 'writable'];

/**
 * Attributes to convert to memoised attributes
 * @type {Array}
 */
var SHOULD_MEMOISE = ['get', 'value'];

/**
 * gain optional memoisation for their respective functions and getter via static "memoised" getter
 * Call on seld
 * @param  {Object}   instance
 * @param  {String[]} props    Properties to wrap in memoizers
 * @return {Object}
 *
 * @example
 * class Klass {
 *   constructor(initial_value = 'nothing') {
 *      this.variable = initial_value;
 *      memoise(this, 'a_getter', 'a_function');
 *   }
 *
 *   // I will be memoised
 *   get a_getter() {
 *     return this.variable;
 *   }
 *
 *   // I will not be memoised
 *   get a_dynamic_getter() {
 *     return this.variable;
 *   }
 *
 *   // I will be memoised
 *   a_function() {
 *     return `The value is ${this.variable}`;
 *   }
 * }
 */
function memoizer(instance) {

    /**
     * Private memory store
     * @type {Object}
     */
    var memory = {};

    /**
     * memoize values of operations by key
     * @private
     * @param  {String}   item     Key of item to memoize
     * @param  {Function} retreive Operation to calculate the value
     * @return {Any}
     */
    function memoize(item, retreive) {
        return memory[item] = memory.hasOwnProperty(item) ? memory[item] : retreive();
    }

    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    props.forEach(function (property) {
        return assignDescriptorProperties.call(instance, property, memoize);
    });
}

/**
 * Assigns new descriptor properties. Getter and Values will be wrapped in a memoize method
 * @param  {String}   property Property name
 * @param  {Function} memoize  How to memoize the result
 * no return value
 */
function assignDescriptorProperties(property, memoize) {
    var _this = this;

    var descriptor = Object.getOwnPropertyDescriptor(this.constructor.prototype, property);

    var attributes = OBJECT_PROPERTY_ATTRIBUTES.reduce(function (attributes, attribute) {
        switch (memoizer__typeof(descriptor[attribute])) {
            case 'undefined':

                // do nothing
                break;
            case 'function':
                if (SHOULD_MEMOISE.includes(attribute)) {
                    attributes[attribute] = function () {
                        return memoize(property + '$' + attribute, descriptor[attribute].bind(_this));
                    };
                } else {
                    attributes[attribute] = descriptor[attribute];
                }
                break;
            default:
                attributes[attribute] = descriptor[attribute];
                break;
        }

        return attributes;
    }, {});

    Object.defineProperty(this, property, attributes);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/env/__isBrowserLike/index.mjs
/**
 * @module isBrowserLike
 * @requires glob
 * @private
 * @since 2.3.1
 */



/**
 * Test whether the current environment is a browser-like environment or not.
 * @return {Boolean}
 */
var __isBrowserLike_isBrowserLike = function isBrowserLike() {
  return glob.document && typeof glob.document.createElement === 'function';
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/env/index.mjs
var env__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module env
 * @since 2.0.0
 * @requires glob
 * @requires resolve
 * @requires memoizer
 */






/**
 * @class Env
 * @augments Memoiser
 * @classdesc Figure out details regarding the runtime environment. Bridges server and browser
 * @property {Boolean} node        Is this environment a nodejs environment?
 * @property {Boolean} browser     Is this environment a browser or a browser-like environment?
 * @property {Boolean} development Is this environment defined as a development environment @alias dev
 * @property {Boolean} production  Is this environment defined as a testing environment @alias prod
 * @property {Boolean} testing     Is this environment defined as a testing environment @alias test
 * @property {Boolean} plike       Is this environment defined as a plike environment (production like)
 *
 * @example
 * window.app = {environment: 'production'};
 * env.prod // true
 *
 * export NODE_ENV=production; npm start
 * env.prod // true
 */

var env_Env = function () {
    function Env() {
        _classCallCheck(this, Env);

        // getters and functions that should be memoised
        memoizer(this, 'node', 'browser', 'development', 'production', 'testing', 'plike', 'toString');
    }

    _createClass(Env, [{
        key: 'toString',


        /**
         * @return {String} Value of environment set where applicable
         */
        value: function toString() {
            var env = this.browser ? resolve_resolve('app.environment') : resolve_resolve('process.env.NODE_ENV');

            return (env || '').toLowerCase();
        }
    }, {
        key: 'node',
        get: function get() {
            return Object.prototype.toString.call(typeof glob.process !== 'undefined' ? glob.process : 0) === '[object process]';
        }
    }, {
        key: 'browser',
        get: function get() {
            return __isBrowserLike_isBrowserLike() || !this.node && [typeof document === 'undefined' ? 'undefined' : env__typeof(document), typeof window === 'undefined' ? 'undefined' : env__typeof(window)].every(function (item) {
                return item !== 'undefined';
            });
        }
    }, {
        key: 'development',
        get: function get() {
            return this.toString().includes('dev');
        }
    }, {
        key: 'dev',
        get: function get() {
            return this.development;
        }
    }, {
        key: 'production',
        get: function get() {
            return this.toString().includes('prod');
        }
    }, {
        key: 'prod',
        get: function get() {
            return this.production;
        }
    }, {
        key: 'testing',
        get: function get() {
            return this.toString().includes('test');
        }
    }, {
        key: 'test',
        get: function get() {
            return this.testing;
        }
    }, {
        key: 'plike',
        get: function get() {
            return this.toString().includes('like');
        }
    }]);

    return Env;
}();

var env_env = new env_Env();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/emerge/index.mjs
/**
 * @module emerge
 * @since 2.0.0
 */



/**
 * Triggers a callback when an element "emerges", i.e. becomes visible on it's own or by inheritance
 * @param  {HTMLElement} element
 * @return {Promise} Promise resolves with given HTML element as an argument
 *
 * @example
 * emerge(document.querySelector('.my-content'))
 *   .then(() => { console.log('My content is visible'); })
 *   .catch((error) => { throw error; });
 */
var emerge_emerge = function emerge(element) {
    return new Promise(function (resolve, reject) {
        if (!env_env.browser) {
            reject('emerge can not be triggered from a non browser environment');
        }

        var hiddenContainer = getTraversedHidden(element);

        if (hiddenContainer === null) {
            resolve(element);
            return;
        }

        if (typeof MutationObserver === 'undefined') {
            // Unsupported. Pretend like you've emerged

            resolve(element);
            return;
        }

        var observer = new MutationObserver(function () {
            if (getTraversedHidden(element) === null) {
                resolve(element);
                observer.disconnect();
            }
        });

        observer.observe(hiddenContainer, { attributes: true });
    });
};

/**
 * Retrieve the first element which is set to display:none. Returns null when none are found
 * @private
 * @param  {HTMLElement} element
 * @return {HTMLElement|null}
 */
function getTraversedHidden(element) {
    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    if (width !== 0 || height !== 0) {
        return null;
    }

    while (element) {
        if (element === document.body) {

            // Break the loop two iterations early
            return null;
        }

        if (window.getComputedStyle(element).display === 'none') {

            // Break iteration with retrieve "hidden" element
            return element;
        }

        element = element.parentElement;
    }

    return element;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/exposed/__rect/index.mjs
/**
 * @module rect
 * @private
 * @since 2.0.0
 */

/**
 * @typedef RectObject
 * @type     {Object}
 * @property {number} left   Y of left end
 * @property {number} top    X of top end
 * @property {number} right  Y of right end
 * @property {number} bottom X of bottom end
 * @property {number} width
 * @property {number} height
 */

/**
 * Get size object for relevant DOM element
 * @param  {DOMElement|Window|Document} element
 * @return {RectObject}
 */
function rect(element) {
    if (element instanceof Window || element instanceof HTMLDocument) {
        return {
            left: 0,
            top: 0,
            right: window.innerWidth,
            bottom: window.innerHeight,
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    var _element$getBoundingC = element.getBoundingClientRect(),
        left = _element$getBoundingC.left,
        top = _element$getBoundingC.top,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom,
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        width: width,
        height: height
    };
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/exposed/index.mjs
var exposed__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * @module exposed
 * @since 1.7.0
 * @requires exposed/rect
 */



/**
 * Subtract first number from second
 * @private
 * @param  {number} a
 * @param  {number} b
 * @return {number}
 */
var sub = function sub(a, b) {
  return a - b;
};

/**
 * Subtract second number from first
 * @private
 * @param  {number} a
 * @param  {number} b
 * @return {number}
 */
var revSub = function revSub(a, b) {
  return b - a;
};

/**
 * @typedef  ExposedOptions
 * @type     {Object}
 * @property {DOMElement|Window} [container=window]
 * @property {number}            [percent=50]
 */

/**
 * Is element inside container. For the result to be true, the element must be exposed by the given percent (50% by default) on both axis X and Y.
 * @param  {DOMElement}     element
 * @param  {ExposedOptions} [options] <a href="#~ExposedOptions">ExposedOptions</a>
 * @return {boolean}
 *
 * @example
 * const container = document.querySelector('.my-slideshow-wrapper');
 * const element = container.querySelector('.slide');
 * exposed(
 *   element,
 *   {
 *       container,
 *       percent: 75
 *   }
 * );
 */
function exposed(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$container = _ref.container,
      container = _ref$container === undefined ? window : _ref$container,
      _ref$percent = _ref.percent,
      percent = _ref$percent === undefined ? 50 : _ref$percent;

  var inner = rect(element);
  var outer = rect(container);
  var fraction = percent / 100; // fraction of surface we want exposed

  /**
   * @typedef  SufficiantlyExposedArguments
   * @type     {Array}
   * @property {string}   0 [prop] - Property we're going to measure
   * @property {string}   1 [measurement] - Element's axis
   * @property {function} 2 [calculator] - Function for calculating the diff
   */

  /**
   * Element is sufficiently exposed (on 1 axis)
   * @param  {SufficiantlyExposedArguments} [argument] <a href="#~SufficiantlyExposedArguments">SufficiantlyExposedArguments</a>
   * @return {boolean}
   */
  var sufficiantlyExposed = function sufficiantlyExposed(_ref2) {
    var _ref3 = exposed__slicedToArray(_ref2, 3),
        prop = _ref3[0],
        measurement = _ref3[1],
        calculator = _ref3[2];

    return calculator(inner[prop], outer[prop]) + inner[measurement] >= inner[measurement] * fraction;
  };

  if (['width', 'height'].some(function (prop) {
    return inner[prop] === 0;
  })) {
    return false;
  }

  // Checks are performed ordered by likelihood of failure (most to least)
  //   considering some checks stop after one success
  return [['top', 'height', sub], ['left', 'width', sub], ['right', 'width', revSub], ['bottom', 'height', revSub]].every(sufficiantlyExposed);
}
// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_","var":"_"}
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______ = __webpack_require__("PbPb");
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default = /*#__PURE__*/__webpack_require__.n(external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/__alias/index.mjs
var __alias__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module alias
 * @private
 * @since 2.0.0
 */

/**
 * Check if a function exist on the global Fiverr object
 * @param  {String} name The function name
 * @return {Boolean}
 */
var available = function available(name) {
  return (typeof Fiverr === 'undefined' ? 'undefined' : __alias__typeof(Fiverr)) === 'object' && typeof Fiverr[name] === 'function' ? true : undefined;
};

/**
 * Creates a "safe" alias for a Fiverr function
 * @param  {string} name Function name
 * @return {Function}
 */
var alias = function alias(name) {
  return function () {
    var _Fiverr;

    return available(name) && (_Fiverr = Fiverr)[name].apply(_Fiverr, arguments);
  };
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendEvents/index.mjs
/**
 * @module sendEvents
 * @alias Fiverr.sendClientEvents
 * @since 2.0.0
 */



/**
 * Report BI events to server. Aliases Fiverr.sendClientEvents
 * @param  {...Object[]} event TBC
 * no return value
 *
 * @example
 * Fiverr.sendEvents(
 *   {...},
 *   {...},
 *   {...}
 * )
 */
var sendEvents = alias('sendClientEvents');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendGraph/index.mjs
/**
 * @module sendGraph
 * @alias Fiverr._logEventToGraphite
 * @since 2.0.0
 */



/**
 * @typedef   MonitoringObject
 * @type      {Object}
 * @property  {String} options.label            Key of the table
 * @property  {Number} [options.timing]         Value for timers in milliseconds
 * @property  {Number} [options.value]          Value for counters
 * @property  {Number} [options.percentage=5]   Percentage of events to actually send
 * @property  {Number} [options.ttl=300]        Time to delay between reports (milliseconds)
 */

/**
 * Report statistical data. Aliases Fiverr._logEventToGraphite
 * @param {MonitoringObject} options Data for the report
 * no return value
 *
 * @example
 * sendGraph({
 *   label: 'fe_events.flow_name.interaction',
 *   percentage: 100,
 * })
 *
 * sendGraph({
 *   label: 'fe_events.flow_name.process',
 *   timing: 2000,
 *   percentage: 100,
 * })
 */
var sendGraph = alias('_logEventToGraphite');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/__Storage/index.mjs
var __Storage__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function __Storage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module Storage
 * @private
 * @since 2.0.0
 * @requires memoizer
 * @requires env
 */




/**
 * Common interface for localStorage and sessionStorage
 */
var __Storage_Storage = function () {
    function Storage(key) {
        var _this = this;

        __Storage__classCallCheck(this, Storage);

        memoizer(this, 'available');

        this.storage = env_env.browser && window[key];

        ['get', 'set'].forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
    }

    /**
     * available Is localStorage available
     * @type {Boolean}
     */


    __Storage__createClass(Storage, [{
        key: 'get',


        /**
         * S.get
         * @param  {String} key           Key name
         * @return {Any} Value. If value can be parsed as JSON it'll be parsed as JSON
         */
        value: function get(key) {
            if (!this.available) {
                return;
            }

            var value = this.storage.getItem(key);

            try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
        }

        /**
         * S.set
         * @param  {String} key   Key name
         * @param  {Any}    value Value to store
         * @return {Promise}
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this2 = this;

            if (!this.available) {
                return new Promise(function (resolve) {
                    return resolve;
                });
            }

            return new Promise(function (resolve, reject) {
                try {
                    _this2.storage.setItem(key, JSON.stringify(value));
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        }

        /**
         * S.remove
         * @param {String} key Key name
         * no return value
         */

    }, {
        key: 'remove',
        value: function remove(key) {
            this.available && this.storage.removeItem(key);
        }

        /**
         * S.size
         * @param  {...String} [keys] When omitted calculates all
         * @return {Object}           map of sizes. Includes "total"
         */

    }, {
        key: 'size',
        value: function size() {
            var _this3 = this;

            for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
                keys[_key] = arguments[_key];
            }

            var all = !keys.length;
            var total = 0;
            all && (keys = Array.from(Array(this.storage.length)).map(function (item, index) {
                return _this3.storage.key(index);
            }));

            var result = keys.reduce(function (result, key) {
                var length = (key + _this3.storage.getItem(key)).length;

                result[key] = length;
                all && (total += length);

                return result;
            }, {});

            all && Object.assign(result, { total: total });

            return result;
        }
    }, {
        key: 'available',
        get: function get() {
            if (!env_env.browser) {
                return false;
            }

            var key = Math.random().toString(36).substring(2);

            try {
                this.storage.setItem(key, true);
                this.storage.removeItem(key);
                return true;
            } catch (error) {
                return false;
            }
        }
    }]);

    return Storage;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/localStorage/index.mjs


var localStorage = new __Storage_Storage('localStorage');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/sessionStorage/index.mjs


var sessionStorage = new __Storage_Storage('sessionStorage');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/index.mjs
/**
 * @namespace storage
 * @since 2.0.0
 */




/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} localStorage  @see <a href="identifiers.html#storage-localstorage">localStorage</a>
 * @property {Function} sessionStorage  @see <a href="identifiers.html#storage-sessionstorage">sessionStorage</a>
 */
var storage = {
  localStorage: localStorage,
  sessionStorage: sessionStorage
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/jsonCopy/index.mjs
/**
 * @module jsonCopy
 * @since 2.0.0
 */

/**
 * Copies using JSON functionalities. Very performant, not a comprehensive copyier
 * @param   {Any} data
 * @returns {Any} Deep copy
 */
function jsonCopy(data) {
    try {
        return JSON.parse(JSON.stringify(data));
    } catch (error) {
        throw new SyntaxError("Data was expected to be valid for JSON. Got error: " + error);
    }
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/__CONSTANTS/index.mjs
/**
 * @module impressionable/__CONSTANTS
 * @private
 * @since 2.0.0
 */

/**
 * Throttle events like scroll and resize between DOM querying
 * @type {Number}
 */
var COLLECT_DELAY = 200;

/**
 * custom event that triggers impression collecting
 * @type {String}
 */
var CUSTOM_EVENT = 'collect-impressions';

/**
 * Throttle event report dispatches
 * @type {Number}
 */
var DISPATCH_DELAY = 500;

/**
 * @typedef LISTENER_OPTIONS @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @type {Object}
 * @property {Boolean} capture Dispatch to listener before child event targets
 * @property {Boolean} once    Listener should be removed once invoked
 * @property {Boolean} passive Listener can not call preventDefault()
 */

/**
 * LISTENER_OPTIONS
 * @type {LISTENER_OPTIONS}
 */
var LISTENER_OPTIONS = {
  capture: false,
  once: false,
  passive: false
};

/**
 * Impressionable's storage key
 * @type {String}
 */
var STORAGE_KEY = 'impressionable_events';

/**
 * DOM attribute for "impressed" elements
 * @type {String}
 */
var VIEWED_ATTRIBUTE = 'data-impression-collected';

/**
 * Window events we want to listen to
 * @private
 * @type {String[]}
 */
var WINDOW_LISTENERS = ['load', 'resize', 'scroll', 'touchmove'];
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/__dispatch/index.mjs
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module dispatch
 * @private
 * @since 2.0.0
 */






/**
 * Empty events from localStorage and send them
 * no return value
 */
function dispatch() {
    var events = localStorage.get(STORAGE_KEY);

    if (!events) {
        return;
    }

    sendEvents.apply(undefined, _toConsumableArray(events));
    localStorage.set(STORAGE_KEY, []);
}

try {

    /**
     * Throttled run of dispatch
     * @type {Fucntion}
     */
    dispatch.throttled = external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.throttle(dispatch, DISPATCH_DELAY, { leading: false });

    // Report any pre stored events on load

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', dispatch, { once: true });
    } else {
        // interactive, complete
        dispatch();
    }

    window.addEventListener('beforeunload', dispatch, { once: true });
} catch (error) {

    // Fail silently ()probably non browser environment
}


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/index.mjs
var Impressionable__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Impressionable__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Impressionable__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Impressionable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module Impressionable
 * @since 2.0.0
 */












/**
 * @typedef ImpressionableOptions
 * @type {Object}
 * @property {Object[]}     [data=[]]                         Array of BI data objects. Each must have an identifier
 * @property {HTMLElement}  [container=window]                Container of the carousel
 * @property {String}       [DOMSelector=`[${DOMAttribute}]`] QuerySelector of the children
 * @property {String}       [DOMAttribute='id']               DOM attribute holding the item's identifier
 * @property {String}       [dataIdentifier='id']             Data member holding the item's identifier
 * @property {String}       [dataProperty]                      Data member representing the impression event
 * @property {EnrichLambda} [enrich]
 */

/**
 * A lambda expression width privileged access to the event data item. Is meant to mutate it (usually add properties)
 * @callback EnrichLambda
 * @param    {Object}                 data    The event data item (Mutable), enriched items: $index
 * @param    {HTMLElement}            [child] The element corresponding to the DOMSelector-DOMAttribute-dataIdentifier combination.
 * @returns  {Object|undefined|false}         Optionally: return a new event object. Returning false will prevent the send of the impression
 *
 * @example
 * // Add a new item to the event
 * new Impressionable({
 *   enrich: (event) => { event.source_url = window.location.href; }
 * })
 *
 * // Replace event
 * new Impressionable({
 *   enrich: (event, element) => Object.assign(
 *     {},
 *     event,
 *     {
 *       type: 'some_other_type',
 *       position: event.$index + 1,
 *       url: window.location.href,
 *       offsetTop: element.offsetTop,
 *     }
 *   )
 * })
 */

/**
 * Options defaults
 * @type {ImpressionableOptions}
 */
var defaults = {
    data: [],
    container: typeof window !== 'undefined' ? window : null,
    DOMAttribute: 'id',
    dataIdentifier: 'id'
};

/**
 * @class Impressionable
 * @classdesc an impression tracker. Using a container, a data collection and a child selector, the wrapper
 * @param  {ImpressionableOptions}   options
 * @property {ImpressionableOptions} options
 * @property {Array}                 impressed   Array representation of NodeList
 * @property {Array}                 unimpressed Array representation of NodeList
 * @property {Boolean}               retired     Whether this instance is retired or not.
 *
 * @example
 * const impressionable = new Impressionable({
 *   data: [{id: 0, name: 'a1vy', impression_data: {id: 0, group: 'event_group', type: 'event_type'}}],
 *   container: document.getElementById('my_container'),
 *   DOMSelector: '.card',
 *   DOMAttribute: 'data-impression-id',
 *   dataIdentifier: 'id',
 *   dataProperty: 'impression_data',
 *   enrich: (event, element) => Object.assign(event, {
 *     position: event.$index + 1,
 *     url: window.location.href,
 *     offsetTop: element.offsetTop,
 *   })
 * })
 *
 * // Triggering after custom scrolling
 * container.addEventListener('transitionend', () => container.dispatchEvent(new CustomEvent('collect-impressions')))
 * // - OR -
 * container.addEventListener('transitionend', impressionable.collect);
 * // - OR -
 * setTimeout(impressionable.collect, 400)
 */
var Impressionable_Impressionable = function () {
    function Impressionable() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        Impressionable__classCallCheck(this, Impressionable);

        if (!env_env.browser) {
            throw new Error('Impressionable can not be instantiated from a non browser environment');
        }

        this.options = Object.assign({}, defaults, options);

        // Other defaults
        this.options.DOMSelector = this.options.DOMSelector || '[' + this.options.DOMAttribute + ']';

        var _options = this.options,
            data = _options.data,
            container = _options.container,
            DOMSelector = _options.DOMSelector,
            dataProperty = _options.dataProperty,
            dataIdentifier = _options.dataIdentifier;


        if (!Array.isArray(data)) {
            throw new TypeError('Impressionable must receive a "data" array argument. Got ' + (typeof data === 'undefined' ? 'undefined' : Impressionable__typeof(data)));
        }

        var queryRoot = container === window ? document.body : container;
        if (!queryRoot) {
            throw new Error('Impressionable container (when passed) expects a DOM element. Got a ' + (typeof container === 'undefined' ? 'undefined' : Impressionable__typeof(container)));
        }
        var children = queryRoot.querySelectorAll(DOMSelector);

        Object.assign(this, {
            container: container,
            impressed: [],
            unimpressed: [].slice.call(children) // convert NodeList to Array
        });

        // Convert the data array to a key-value collection for faster lookup
        this.data = this.options.data.reduce(function (collector, item, $index) {
            if (item.hasOwnProperty(dataIdentifier)) {
                collector[item[dataIdentifier]] = Object.assign({ $index: $index }, // takes inferiority
                jsonCopy(dataProperty ? external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.get(item, dataProperty) : item));
            }

            return collector;
        }, {});

        this.collect = external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.throttle(this.collect.bind(this), COLLECT_DELAY, { leading: false });

        this.live();
    }

    /**
     * - Collect the exposed elements' impression data
     * - Move them from "unimpressed" collection to "impressed"
     * - Mark them as "impressed"
     * no return value
     */


    Impressionable__createClass(Impressionable, [{
        key: 'collect',
        value: function collect() {
            var container = this.container;

            var fullyExposed = container === window || exposed(container, { percent: 100 });
            var events = [];

            // Reducing on a shallow copy. The reduction also mutates the array
            var index = this.unimpressed.length;

            while (index--) {
                var child = this.unimpressed[index];

                if (!exposed(child, { container: container })) {
                    continue;
                }

                // verify it's in the viewport
                if (!(fullyExposed || exposed(child))) {
                    continue;
                }

                var impressionData = this.getImpressionData(child);

                if (impressionData) {
                    events.push(impressionData);
                    child.setAttribute(VIEWED_ATTRIBUTE, 'true');
                } else {
                    child.setAttribute(VIEWED_ATTRIBUTE, 'error');
                }

                this.impress(index);
            }

            if (events.length) {
                this.storeImpressions.apply(this, events);
                dispatch.throttled();
            }

            return this;
        }

        /**
         * Move an item from "unimpressed" to "impressed" collection.
         * @param  {number} index Index in "unimpressed" collection.
         * no return value
         */

    }, {
        key: 'impress',
        value: function impress(index) {
            var _impressed;

            (_impressed = this.impressed).push.apply(_impressed, Impressionable__toConsumableArray(this.unimpressed.splice(index, 1)));
            if (!this.unimpressed.length) {
                this.retire();
            }
        }

        /**
         * Retrieve the data item with `id` matching the impression DOMAttribute
         * @param  {HTMLElement} child
         * @return {Object}
         */

    }, {
        key: 'getImpressionData',
        value: function getImpressionData(child) {
            var member = child.getAttribute(this.options.DOMAttribute);
            var data = this.data[member];

            // Enrich data if enrichment method was supplied
            if (typeof this.options.enrich === 'function') {
                var enriched = this.options.enrich(data, child);

                // If enrichment method returns an object, use it
                if ((typeof enriched === 'undefined' ? 'undefined' : Impressionable__typeof(enriched)) === 'object' || enriched === false) {
                    data = enriched;
                }
            }

            return data;
        }

        /**
         * Store impressions in storage (report immediately if unavailable)
         * @param  {...Object} events
         * no return value
         */

    }, {
        key: 'storeImpressions',
        value: function storeImpressions() {
            for (var _len = arguments.length, events = Array(_len), _key = 0; _key < _len; _key++) {
                events[_key] = arguments[_key];
            }

            if (!localStorage.available) {
                sendEvents.apply(undefined, events);

                return;
            }

            this.stored = events;
        }
    }, {
        key: 'live',


        /**
         * Attach throttled listeners to container and window events
         * no return value
         */
        value: function live() {
            var _this = this;

            this.containerEvents.forEach(function (event) {
                return _this.container.addEventListener(event, _this.collect, LISTENER_OPTIONS);
            });

            WINDOW_LISTENERS.forEach(function (event) {
                return window.addEventListener(event, _this.collect, LISTENER_OPTIONS);
            });

            emerge_emerge(this.container).then(this.collect).catch(function (error) {
                throw error;
            });
        }

        /**
         * Detach listeners from container and window events
         * no return value
         */

    }, {
        key: 'die',
        value: function die() {
            var _this2 = this;

            this.containerEvents.forEach(function (event) {
                return _this2.container.removeEventListener(event, _this2.collect, LISTENER_OPTIONS);
            });

            WINDOW_LISTENERS.forEach(function (event) {
                return window.removeEventListener(event, _this2.collect, LISTENER_OPTIONS);
            });
        }

        /**
         * Retires the instance, detaching all event listeneres, and clears out redundant references and properties.
         * no return value
         */

    }, {
        key: 'retire',
        value: function retire() {
            this.retired || Object.assign(this, {
                impressed: [],
                unimpressed: [],
                data: {},
                options: {},
                retired: true
            }).die();
        }
    }, {
        key: 'stored',
        get: function get() {
            return localStorage.get(STORAGE_KEY) || [];
        },
        set: function set(events) {
            var stored = this.stored;

            stored.push.apply(stored, Impressionable__toConsumableArray(events));
            localStorage.set(STORAGE_KEY, stored).catch(function () {
                sendEvents.apply(undefined, Impressionable__toConsumableArray(stored));
                localStorage.remove(STORAGE_KEY);
                sendGraph({
                    label: 'fe_events.error.impressionable.localstorage',
                    timing: localStorage.size(STORAGE_KEY)[STORAGE_KEY],
                    percentage: 100
                });
            });
        }

        /**
         * Expose the custom event name
         * @type string
         */

    }, {
        key: 'containerEvents',


        /**
         * A list of event to listen to on the container
         * @return {Array}
         */
        get: function get() {
            var events = [CUSTOM_EVENT];

            this.container !== window && events.push('scroll', 'touchmove');
            return events;
        }
    }], [{
        key: 'CUSTOM_EVENT',
        get: function get() {
            return CUSTOM_EVENT;
        }
    }]);

    return Impressionable;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/index.mjs
/**
 * @namespace element
 * @since 2.0.0
 */





/**
 * array A collection of array related methods
 * @type     {Object}
 * @property {Class} emerge   @see <a href="identifiers.html#element-emerge">emerge</a>
 * @property {Class} exposed   @see <a href="identifiers.html#element-exposed">exposed</a>
 * @property {Class} Impressionable   @see <a href="identifiers.html#element-impressionable">Impressionable</a>
 */
var element_element = {
  emerge: emerge_emerge,
  exposed: exposed,
  Impressionable: Impressionable_Impressionable
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/event/multiEventListener/index.mjs
/**
 * @module multiEventListener
 * @since 2.0.0
 */

/**
 * Listens to multiple events, and executes a given function when said events are fired.
 * @param {String|String[]}    [events = []]   A list of events to listen to. Can be either an array or a string separated by spaces (a la jQuery).
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget.
 *
 * @param {Function} [callback = () => null]   The function to execute once a certain event fires.
 * @param {Object}   [options]                 An object of extra non-mandatory options.
 * @param {Boolean}  [options.once=false]      Should the callback fire once or not.
 * @param {Element}  [options.element=window}] The element to add the event listeners to.
 *
 * @example
 *
 * multiEventListener(['scroll', 'resize'], () => {console.log('Yo!')});
 *
 * @example
 *
 * multiEventListener(['scroll', 'resize'], () => {console.log('Yo!')}, { once: true });
 */
function multiEventListener() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$once = _ref.once,
      once = _ref$once === undefined ? false : _ref$once,
      _ref$element = _ref.element,
      element = _ref$element === undefined ? window : _ref$element;

  function execute() {
    callback() !== false && once && events.forEach(function (event) {
      return element.removeEventListener(event, execute);
    });
  }

  events = typeof events === 'string' ? events.split(' ') : events;

  events.forEach(function (event) {
    return element.addEventListener(event, execute);
  });
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/event/index.mjs
/**
 * @namespace event
 * @since 2.0.0
 */



/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} multiEventListener  @see <a href="identifiers.html#event-multieventlistener">multiEventListener</a>
 */
var event_event = {
  multiEventListener: multiEventListener
};

// EXTERNAL MODULE: external {"commonjs":"@fiverr/gofor","commonjs2":"@fiverr/gofor","amd":"@fiverr/gofor","root":"goforFactory","var":"goforFactory"}
var gofor___root___goforFactory___var___goforFactory__ = __webpack_require__("jPm4");
var gofor___root___goforFactory___var___goforFactory___default = /*#__PURE__*/__webpack_require__.n(gofor___root___goforFactory___var___goforFactory__);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/gofor/index.mjs
/**
 * @exports gofor
 * @since 1.1.0
 */



/**
 * Get the default options for Fiverr's fetch requests
 * @private
 * @return {Object} default request params:
 *
 * @member {Object<String>} credentials Cross origin credentials
 * @member {Object<Object>} headers Headers:
 *   @member {String} 'X-CSRF-Token'     One time query, one place with the logic
 *   @member {String} 'X-Requested-With' Identify as XHR (this helps our server differentiate the requests from full page requests and take decisions based upon that knowledge)
 *   @member {String} 'Content-Type'     Declare content type JSON as default
 *   @member {String} 'Accept'           Requests JSON by default
 */
var getDefaults = function getDefaults() {
    var headers = defaultHeaders();

    var defaults = {
        credentials: 'same-origin',
        headers: headers
    };

    return defaults;
};

/**
 * Create the default Headers object
 * @return {Headers}
 */
function defaultHeaders() {
    var headers = new Headers();

    headers.append('X-Requested-With', 'XMLHttpRequest');
    headers.append('Content-Type', 'application/json; charset=utf-8');
    headers.append('Accept', 'application/json');

    try {
        headers.append('X-CSRF-Token', document.AUTH_TOKEN);
    } catch (e) {
        // Fail silently
    }

    return headers;
}

var gofor = gofor___root___goforFactory___var___goforFactory___default()(getDefaults);
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/mixin/index.mjs
/**
 * @namespace mixin
 * @since 2.0.0
 */



/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} memoizer  @see <a href="identifiers.html#mixin-memoizer">memoizer</a>
 */
var mixin = {
  memoizer: memoizer
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/number/commaSeparateNumber/index.mjs
/**
 * @exports commaSeparateNumber
 * @since 2.0.0
 */

/**
 * Convert a number to a string representation with commas separating thousands
 * @param  {Number|String} num The number want converted
 * @return {String} representing a number with commas separating thousands
 */
var commaSeparateNumber = function commaSeparateNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/number/index.mjs
/**
 * @namespace number
 * @since 2.0.0
 */



/**
 * number A collection of number related methods
 * @type     {Object}
 * @property {Function} commaSeparateNumber  @see <a href="identifiers.html#number-commaseparatenumber">commaSeparateNumber</a>
 */
var number = {
  commaSeparateNumber: commaSeparateNumber
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/deepAssign/index.mjs
var deepAssign__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module deepAssign
 * @since 1.7.0
 */

/**
 * Checks this object is an assignable object
 * @private
 * @param  {Object} target
 * @return {Boolean} is this object "assignable"
 */
var assignable = function assignable(target) {
  return isObject(target) && ![undefined, null].includes(target);
};

/**
 * Checks a target is an object, excludes null
 * @private
 * @param  {Any} target [description]
 * @return {Boolean} Is the target an object
 */
var isObject = function isObject(target) {
  return ['object', 'function'].includes(typeof target === 'undefined' ? 'undefined' : deepAssign__typeof(target)) && target !== null;
};

/**
 * Delegate to assign keys and symbols
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * @return {Object} Original to, assigned
 */
function deepAssign_assign(to, from) {
  if (Array.isArray(to) && Array.isArray(from)) {
    assignArray(to, from);
    return to;
  }

  to = Object(to);
  from = Object(from);

  assignKeys(to, from);
  assignSymbols(to, from);

  return to;
}

/**
 * Assign second object keys to first
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * no return value
 */
var assignKeys = function assignKeys(to, from) {
  return Object.keys(from).forEach(function (key) {
    return assignKey(to, from, key);
  });
};

/**
 * Assign second object symbols to first
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * no return value
 */
var assignSymbols = function assignSymbols(to, from) {
  return getOwnPropertySymbols(from).forEach(function (symbol) {
    return assignKey(to, from, symbol);
  });
};

/**
 * Assign members of second array to first
 * @private
 * @param  {Array} to    Target array to assign to
 * @param  {Array} from  The array from which to assign respective values
 * no return value
 */
var assignArray = function assignArray(to, from) {
  return from.forEach(function (item, index) {
    return assignable(to[index]) && assignable(item) ? deepAssign_assign(to[index], item) : to.push(item);
  });
};

/**
 * Perform getOwnPropertySymbols when available
 * @private
 * @param  {Object} object
 * @return {Array} List of symbol keys (falls back to an empty array)
 */
var getOwnPropertySymbols = function getOwnPropertySymbols(object) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : [];
};

/**
 * assign one key from one object to the target
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object to assign value
 * @param  {String|Symbol} key
 * no return value
 */
function assignKey(to, from, key) {
  var easyAssign = !to.hasOwnProperty(key) || !assignable(from[key]);

  to[key] = easyAssign ? from[key] : deepAssign_assign(clone(to[key]), from[key]);
}

/**
 * Create a shallow clone of a given Object or Array
 * @private
 * @param  {Object|Array} instance Object or Array to clone
 * @return {Object|Array} (respectively) a shallow clone
 */
var clone = function clone(instance) {
  return Array.isArray(instance) ? instance.slice(0) : Object.assign({}, instance);
};

/**
 * Deep object assignment
 * @param  {Object}    target Target object to assign to
 * @param  {...Object} others The objects from which to deep assign respective values
 * @return {Object} Original target, assigned
 *
 * @example deepassign({hash: {a: 1}}, {hash: {b: 2, c: 0}}, {hash: {c: 3}}) // {hash: {a: 1, b:2, c: 3}}
 */
function deepAssign(target) {
  for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  assignable(target) && others.forEach(function (other) {
    return deepAssign_assign(target, other);
  });

  return target;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/select/index.mjs
/**
 * @module select
 * @since 1.3.0
 */

/**
 * Return an object's shallow copy filtering members based by a function
 *
 * @param  {Object} original key value pair
 * @param  {Function} condition function accepting key, value as parameters and returning a boolean
 * @return {Object} key value pair
 *
 * @example select({a:1, b:2, c:3, d:4}, (key, val) => val > 2);
 * // {c:3, d:4}
 */
function select_select(original) {
    var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return false;
    };

    var result = {};

    for (var key in original) {
        if (condition(key, original[key])) {
            result[key] = original[key];
        }
    }

    return result;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/index.mjs
/**
 * @namespace object
 * @since 2.0.0
 */




/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} deepAssign  @see <a href="identifiers.html#object-deepassign">deepAssign</a>
 * @property {Function} select  @see <a href="identifiers.html#object-select">select</a>
 */
var object = {
  deepAssign: deepAssign,
  select: select_select
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/random/uid/index.mjs
/**
 * @module uid
 * @since 2.1.0
 */

/**
 * Generate a pseudorandom namespaced id
 *
 * @param  {String}  namespace Optional namespace for ID
 * @return {String}  pseudorandom id derived from timestamp
 *
 * @example uid('Fiverr');
 * // Fiverr_9807528710537
 */

function uid() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var generatedString = ('' + Math.random()).slice(-8) + ('' + Date.now()).slice(8);
  var prefix = namespace ? namespace + '_' : '';
  return '' + prefix + generatedString;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/random/index.mjs
/**
 * @namespace random
 * @since 2.1.0
 */



/**
 * A collection of randomizer functions
 * @type     {Object}
 * @property {Function} uid  Generates a pseudorandom namespaced uid
 */

var random = {
  uid: uid
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/stripOperators/index.mjs
/**
 * @module stripOperators
 * @since 1.6.0
 */

/**
 * Regex operators match
 * @private
 * @type {RegExp}
 */
var OPERATORS_MATCH = /[|\\{}()[\]^$+*?.]/g;

/**
 * return a string with stripped operators
 * @param  {String} string
 * @param  {String} [replacement='']
 * @return {String} a string safe for RegExp
 *
 * @example stripOperators('weird things)') // => 'weird things'
 */
var stripOperators = function stripOperators() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return string.replace(OPERATORS_MATCH, replacement);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/StrippedRegExp/index.mjs
function StrippedRegExp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @module StrippedRegExp
 * @since 1.5.0
 */



/**
 * @class StrippedRegExp
 * @extends RegExp
 * @classdesc Create a RegExp from string ignoring operators
 *
 * @example new StrippedRegExp('weird stuff)', 'g')
 */
var StrippedRegExp_StrippedRegExp = function (_RegExp) {
  _inherits(StrippedRegExp, _RegExp);

  /**
   * constructor
   * @param {String|RegExp} pattern
   * @param {String} [flags]
   * @returns {RegExp} a regex object ignoring operators
   */
  function StrippedRegExp() {
    var _ref;

    StrippedRegExp__classCallCheck(this, StrippedRegExp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') {
      args[0] = stripOperators(args[0]);
    }

    return _possibleConstructorReturn(this, (_ref = StrippedRegExp.__proto__ || Object.getPrototypeOf(StrippedRegExp)).call.apply(_ref, [this].concat(args)));
  }

  return StrippedRegExp;
}(RegExp);
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/index.mjs
/**
 * @namespace regexp
 * @since 2.0.0
 */




/**
 * regexp A collection of regexp related methods
 * @type     {Object}
 * @property {Function} stripOperators @see <a href="identifiers.html#regexp-stripoperators">stripOperators</a>
 * @property {Class}    StrippedRegExp @see <a href="identifiers.html#regexp-strippedregexp">StrippedRegExp</a>
 */
var regexp = {
  stripOperators: stripOperators,
  StrippedRegExp: StrippedRegExp_StrippedRegExp
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/safe/index.mjs
/**
 * @module safe
 * @since 1.0.0
 */

/**
 * No operation function accept anything
 * @private
 * @return {undefined} return nothing
 */
function noop() {} /* Do nothing */

/**
 * Perform a safe call on a method. Ignore other types
 *
 * @param  {Function|Any} fn          What may be a function to run
 * @param  {Object}       [context] The context to call the function on
 * @param  {...Any[]}     [args]    Other arguments to pass onto the function
 * @return {Any}
 *
 * @example
 * safe((a, b, c) => console.log(a + b + c), this, 'A', 'B', 'C');
 * // 'ABC'
 */
var safe = function safe(fn, context) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return (typeof fn === 'function' ? fn : noop).apply(context || null, args || []);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendError/index.mjs
/**
 * @module sendError
 * @alias Fiverr._logErrorToServer
 * @since 1.7.0
 */



/**
 * Report error to server. Aliases Fiverr._logErrorToServer
 * @param  {string} file
 * @param  {string} method
 * @param  {string} error
 * no return value
 *
 * @example
 * sendError('my_file.js', 'my_method_name', `expected argument to be string got ${typeof arguments[0]}`)
 */
var sendError = alias('_logErrorToServer');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/index.mjs
/**
 * @namespace send
 * @since 2.0.0
 */





/**
 * object A collection of senders methods
 * @type     {Object}
 * @property {Function} sendError  @see <a href="identifiers.html#send-senderror">sendError</a>
 * @property {Function} sendEvents  @see <a href="identifiers.html#send-sendevents">sendEvents</a>
 * @property {Function} sendGraph  @see <a href="identifiers.html#send-sendgraph">sendGraph</a>
 */
var send = {
  sendError: sendError,
  sendEvents: sendEvents,
  sendGraph: sendGraph
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/capitalize/index.mjs
/**
 * @module capitalize
 * @since 1.4.0
 */

/**
 * Uppercase first character
 * @private
 * @param  {String} string Any string
 * @return {String} A string where the first character is uppercased
 */
var cap = function cap(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Uppercase first character of a sentence or each word in a string
 * @param  {String}  [string=''] A word or a sentence
 * @param  {Boolean} [all=false] Should capitalize every first letter of a word in a sentence
 * @return {String}
 *
 * @example
 * capitalize('martin prince') // 'Martin prince'
 * capitalize('martin prince', true) // 'Martin Prince'
 */
var capitalize = function capitalize() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return all ? string.split(' ').map(cap).join(' ') : cap(string);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/interpolator/index.mjs
var interpolator__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module interpolator
 * @since 1.9.0
 */

/**
 * Valid types of results for the interpolated string
 * @private
 * @type {Array}
 * @member {String|Number}
 */
var VALID_RESULT_TYPES = Object.seal(['string', 'number']);

/**
 * Create new interpolator method instance
 * @param  {...RegExp[]} replacers
 * @returns {Function} interpolate function instance
 *
 * @example const interpolate = interpolator(/\${([^{}]*)}/gm);
 *
 * interpolate('Hello, ${name}', {name: 'Martin'})
 */
var interpolator = function interpolator() {
  for (var _len = arguments.length, replacers = Array(_len), _key = 0; _key < _len; _key++) {
    replacers[_key] = arguments[_key];
  }

  return (

    /**
     * interpolate description
     * @param  {String} string Template
     * @param  {Object} data   Data for filling
     * @return {String}        Result
     */
    function interpolate() {
      var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments[1];

      if (typeof string !== 'string') {
        throw new TypeError('interpolator expects first argument to be a string, got a ' + (typeof string === 'undefined' ? 'undefined' : interpolator__typeof(string)));
      }

      if (!data) {
        return string;
      }

      /**
       * Replace method build with internal reference to the passed in data structure
       * @param  {String} haystack The full string match
       * @param  {String} needle   The content to identify as data member
       * @return {String}          Found value
       */
      function replace(haystack, needle) {
        var replacement = data[needle.trim()];

        return ~VALID_RESULT_TYPES.indexOf(typeof replacement === 'undefined' ? 'undefined' : interpolator__typeof(replacement)) ? replacement : haystack;
      }

      return replacers.reduce(function (string, replacer) {
        return string.replace(replacer, replace);
      }, string);
    }
  );
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/index.mjs
/**
 * @namespace string
 * @since 2.0.0
 */




/**
 * string A collection of string related methods
 * @type     {Object}
 * @property {Function} capitalize @see <a href="identifiers.html#string-capitalize">capitalize</a>
 * @property {Function} interpolator @see <a href="identifiers.html#string-interpolator">interpolator</a>
 */
var string_string = {
  capitalize: capitalize,
  interpolator: interpolator
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/tab/index.mjs
var tab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module tab
 * @since 2.1.0
 */



var ACTIVE_TAB = 'VdOMGFYWmxYM1JoWWc';
var FOCUS = 'focus';

/**
 * @class Tab
 * @classdesc Register most recently active tab in local storagae
 * @property {String}   uid             Current tab uid
 * @property {Set}      whenActive      Set containing functions to call when active
 * @property {Map}      focusHandlers   Map between callbacks and subscripion IDs
 * @property {Fucntion} setActiveTab    A bound instance of setActiveTab
 */

var tab_Tab = function () {
    function Tab() {
        tab__classCallCheck(this, Tab);

        if (!env_env.browser) {
            throw new Error('[fUtile][Tab][Constructor] Module should only be used in the browser');
        }

        this.uid = random.uid('TAB');
        this.setActiveTab = this.setActiveTab.bind(this);
        this.whenActive = new Set();
        this.focusHandlers = new Map();
        this.setActiveTab();
        this.onFocus(this.setActiveTab);
    }

    /**
     * @return {String} Current active tab value from local storage
     */


    tab__createClass(Tab, [{
        key: 'setActiveTab',


        /**
         * Sets the current tab as the active tab in localStorage
         */
        value: function setActiveTab() {
            if (this.isActive) {
                return;
            }
            localStorage.set(ACTIVE_TAB, this.uid);

            this.whenActive.forEach(function (callback) {
                return callback();
            });
        }

        /**
         * @return {Boolean} Is the current tab the active tab stored in localStoarge
         */

    }, {
        key: 'onSetActive',


        /**
         * Accepts a function to call when tab is set to active
         * @param {Function} callback a function to add to `whenActive` set
         * @example
         * tab().onSetActive(() => console.log('I\'m active now'))
         */
        value: function onSetActive(callback) {
            typeof callback === 'function' && this.whenActive.add(callback);
        }

        /**
         * Accepts a function to call when tab gets focused
         * @param {Function} callback a function to add to `focusHandlers` Map
         * @returns {String} subscription ID for unsubscribing
         * @example
         * tab().focusSubscribe(() => console.log('I\'m focused now'))
         */

    }, {
        key: 'focusSubscribe',
        value: function focusSubscribe(callback) {

            if (typeof callback !== 'function') {
                return null;
            }

            var subscriptionId = random.uid();
            this.onFocus(callback);
            this.focusHandlers.set(subscriptionId, callback);
            return subscriptionId;
        }

        /**
         * Unsubscribe a specific subscription from focus event
         * @param {String} subscriptionId subscription ID to remove from Map
         * @example
         * tab().focusUnsubscribe('2452435435')
         */

    }, {
        key: 'focusUnsubscribe',
        value: function focusUnsubscribe(subscriptionId) {
            window.removeEventListener(FOCUS, this.focusHandlers.get(subscriptionId));
        }

        /**
         * Binds `focus` event to a given callback
         */

    }, {
        key: 'onFocus',
        value: function onFocus(callback) {
            window.addEventListener(FOCUS, callback);
        }
    }, {
        key: 'activeTab',
        get: function get() {
            return localStorage.get(ACTIVE_TAB);
        }
    }, {
        key: 'isActive',
        get: function get() {
            return this.activeTab === this.uid;
        }
    }]);

    return Tab;
}();

var identifier = ACTIVE_TAB;

/**
 * consistently exports the same Tab instance
 * @returns {Tab} singleton instance of Tab
 * @example
 * if (tab().isActive) {
 *     shutDown();
 * }
 */
var tab_tab = function tab() {
    return glob[identifier] = glob[identifier] || new tab_Tab();
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/formDataIterable/index.mjs
/**
 * @module formDataIterable
 * @since 2.0.0
 */

/**
 * Generates an  iterable array member from a form element.
 * @param  {HTMLInputElement} field An HTML form input element.
 * @return {Array}
 */
var iteratize = function iteratize(field) {
    return [field.name, field.value];
};

/**
 * Generates an iterable array from a form element in a manner compliant with all browsers.
 * @param  {HTMLFormElement} formElement a <form> element.
 * @return {Array}                       An iterable array, similar to FormData.entries().
 */
function formDataIterable(formElement) {
    return [].reduce.call(formElement.elements, function (data, field) {
        switch (field.type) {
            case 'submit':
            case 'button':
            case 'reset':
            case 'file':
                break;
            case 'checkbox':
            case 'radio':
                field.checked && data.push(iteratize(field));
                break;
            case 'select-multiple':
                [].forEach.call(field.options, function (option) {
                    option.selected && data.push([field.name, option.value]);
                });
                break;
            default:
                data.push(iteratize(field));
                break;
        }

        return data;
    }, []);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__validValue/index.mjs
/**
 * @module __validValue
 * @private
 * @since 1.4.0
 */

/**
 * Return valid values for a URL parameter's value
 * @param  {String} value The value
 * @return {String|Boolean} empty string is considered true, everything else gets URI decoded
 *
 * @example validValue('%2425');
 * // '$25'
 */
var validValue = function validValue(value) {
  return value === undefined ? true : decodeURIComponent(value);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__breakPair/index.mjs
var __breakPair__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module __breakPair
 * @private
 * @since 1.4.0
 */



/**
 * Break a query key=value pair to an array containing key and value respectively
 * @param  {String} item Representation of key value pair 'key=value'
 * @return {Object}
 *
 * @example breakPair('key=value') // {key: 'value'}
 */
function breakPair(item) {
  var _item$split = item.split('='),
      _item$split2 = __breakPair__slicedToArray(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];

  return key === '' ? {} : _defineProperty({}, key, validValue(value));
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/queryStringToObject/index.mjs
function queryStringToObject__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module queryStringToObject
 * @description Convert query string structure to a Javascript object
 * @since 1.4.0
 */



/**
 * Convert query string to key value pairs object
 * @param  {String} string Complete query string (w/o the mod)
 * @return {Object}
 *
 * @example
 * queryStringToObject('param1=value1&param2=value2') // {param1: 'value1', param2: 'value2'}
 */
var queryStringToObject_queryStringToObject = function queryStringToObject() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Object.assign.apply(Object, queryStringToObject__toConsumableArray(string.split('&').map(breakPair)));
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/serializeObject/index.mjs
var serializeObject__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module serializeObject
 * @since 2.0.0
 */

var DEFAULT_DELIMITERS = {
    pair: '=',
    values: '&'
};

/**
 * Serializes an Object into a digestable string.
 * @param  {Object|Array[]} source    Either a flat object, or an entries array ([[k, v], [k, v]]).
 * @param  {Object} delimiters        A map of delimiters to join the string by.
 * @param  {String} delimiters.pair   A character to join pairs of key-value by.
 * @param  {String} delimiters.values A character to join values by.
 * @return {String}                   Serialized parameters string.
 * @example
 * var delimiters = {
 *  pair: ':',
 *  values: '|'
 * }
 *
 * serializeObject(object) // 'a=this&b=is%20cool'
 * serializeObject(object, delimiters) // 'a:this|b:is%20cool'
 */
function serializeObject(source, delimiters) {
    var isValid = (typeof source === 'undefined' ? 'undefined' : serializeObject__typeof(source)) === 'object';

    if (!isValid) {
        return null;
    }

    delimiters = Object.assign({}, DEFAULT_DELIMITERS, delimiters);
    var isObject = !Array.isArray(source);
    var entries = isObject ? Object.entries(source) : source;
    var queryString = Array.from(entries, function (param) {
        return param.map(encodeURIComponent).join(delimiters.pair);
    });

    return queryString.join(delimiters.values);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/serializeParams/index.mjs
var serializeParams__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module serializeParams
 * @since 2.0.0
 *
 * @requires env
 * @requires serializeObject
 * @requires URI/formDataIterable
 */





/**
 * Serializes url params using URI encoding.
 * @param  {Object|HTMLFormElement} source Either a flat parameters object, or a <form> element.
 * @return {String}                        Serialized URL parameters string.
 * @example
 * var object = {
 *   a: 'this',
 *   b: 'is cool'
 * }
 *
 * serializeParams(object) // 'a=this&b=is%20cool'
 */
function serializeParams(source) {
  if (!source || (typeof source === 'undefined' ? 'undefined' : serializeParams__typeof(source)) !== 'object') {
    return null;
  }

  var isFormElement = env_env.browser && source instanceof HTMLFormElement;
  var formData = isFormElement ? formDataIterable(source) : Object.entries(source);
  return serializeObject(formData);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/toQueryString/index.mjs
/**
 * @module toQueryString
 * @since 1.4.0
 */

/**
 * Return a valid URL param value, URI encoded value following the equal sign. Empty string returns nothing
 * @private
 * @param  {String} value A value for url param value
 * @return {String}
 *
 * @example
 * equals('Hello'); // '=Hello'
 * equals('$100'); // '=%24100'
 * equals(''); // ''
 */
var equals = function equals(value) {
  return value === true ? '' : '=' + encodeURIComponent(value);
};

/**
 * Convert object to a string with a URL params notation
 * @param  {Object} params Parameters object - Key value pair
 * @return {String}
 *
 * @example toQueryString({a: 1, b: true, c: 3}) // 'a=1&b&c=3'
 */
var toQueryString = function toQueryString() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(params).map(function (key) {
    return key + equals(params[key]);
  }).join('&');
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__analyze/index.mjs
var __analyze__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function __analyze__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module __analyze
 * @private
 * @description Analyse parts of the href string
 * @since 1.4.0
 */

/**
 * Create RegExp match methods
 * @private
 * @param  {RegExp} pattern
 * @param  {Number} location in regex result to retrieve
 * @return {Function}
 */
function _regexGetter(pattern, location) {
  /**
   * Get match or empty string
   * @param  {String} string
   * @return {String}
   */
  return function (string) {
    var match = string.match(pattern);

    return match && match[location] || '';
  };
}

/**
 * _patterns regex getter methods storage
 * @private
 * @constant
 * @type {Object<RegExp>}
 */
var _patterns = {};

/**
 * @class Analyze
 * @classdesc Expose a collection of methods to get parts of a URI struct
 *
 * @example (new Analyze()).path('www.website.com/page?param1=1')
 * // www.website.com/page
 */

var Analyze = function () {
  function Analyze() {
    __analyze__classCallCheck(this, Analyze);
  }

  __analyze__createClass(Analyze, [{
    key: 'hash',


    /**
     * @type {Function}
     * @description
     * Get hash string from href
     * @example
     * hash('https://www.website.com/page/file.ext?param1=1#location'); // 'location'
     */
    get: function get() {
      return _patterns.hash = _patterns.hash || _regexGetter(/^.*[\#\!|\#](.*)/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get query string from href
     * @example
     * query('https://www.website.com/page/file.ext?param1=1#location'); // 'param1=1'
     */

  }, {
    key: 'query',
    get: function get() {
      return _patterns.query = _patterns.query || _regexGetter(/^.*\?(.*(?=#)|(.*(?=$)))/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get host string from href
     * @example
     * host('https://www.website.com/page/file.ext?param1=1#location'); // 'www.website.com'
     */

  }, {
    key: 'host',
    get: function get() {
      return _patterns.host = _patterns.host || _regexGetter(/^(.*:[\/]{2}|[\/]{2})?([\w|-|\.]*).*$/, 2); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get top level string from host
     * @example
     * top('www.website.com'); // 'website.com'
     */

  }, {
    key: 'top',
    get: function get() {
      return _patterns.top = _patterns.top || _regexGetter(/localhost$|[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/, 0); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get protocol string from href
     * @example
     * protocol('https://www.website.com/page/file.ext?param1=1#location'); // 'https:'
     */

  }, {
    key: 'protocol',
    get: function get() {
      return _patterns.protocol = _patterns.protocol || _regexGetter(/^(.*:)[\/]{2}|[\/]{2}?.*$/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get path string from href
     * @example
     * path('https://www.website.com/page/file.ext?param1=1#location'); // 'https://www.website.com/page/file.ext'
     */

  }, {
    key: 'path',
    get: function get() {
      return _patterns.path = _patterns.path || function (href) {
        return href.replace(/[\?|#].*$/, '');
      }; // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get pathname string from path and host
     * @example
     * pathname('https://www.website.com/page/file.ext', 'www.website.com'); // '/page/file.ext'
     */

  }, {
    key: 'pathname',
    get: function get() {
      return _patterns.pathname = _patterns.pathname || function (path, host) {
        return host ? path.replace(new RegExp('.*' + host), '') : path;
      };
    }
  }]);

  return Analyze;
}();

/**
 * instance exposed as interface
 * @type {Analyze}
 *
 * @example analyze.path('www.website.com/page?param1=1') // www.website.com/page
 */


var analyze = new Analyze();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/URI/index.mjs
var URI__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function URI__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function URI__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function URI__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module URI
 * @since 1.4.0
 */






/**
 * Key to use for stored calculated values of URI struct
 * @type {Symbol}
 */
var store = typeof Symbol === 'function' ? Symbol() : '_store';

/**
 * Map param types from symbols to names
 * @private
 * @type {Object}
 */
var QUERY_TYPE_DICTIONARY = {
    '#!': 'hashParams',
    '#': 'hashParams',
    '?': 'queryParams'
};

/**
 * Assign key value pair to Self store object, and recreate a frozen store
 * @private
 * @param  {URI}     self context
 * @param  {String}  prop Property to set
 * @param  {Any}     getter
 * @param  {Boolean} [force=true] should set even if the property exists
 * @return {URI}
 */
function _assign(self, prop, getter) {
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (force || !self.store.hasOwnProperty(prop)) {
        self[store] = Object.freeze(Object.assign({}, self.store, URI__defineProperty({}, prop, getter())));
    }

    return self;
}

/**
 * rebuild href string according to new parameters
 * @private
 * @param  {URI} self context
 * @param  {Strong[]} props Properties to use in the rebuilt solution (skip re calculation)
 * @return {URI}
 */
function _rebuild(self) {
    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    self[store] = Object.freeze(Object.assign.apply(Object, URI__toConsumableArray([{
        href: [self.path, self.hasQueryParams() ? '?' + toQueryString(self.queryParams) : '', self.hasHashParams() ? '#' + toQueryString(self.hashParams) : ''].join('')
    }].concat(props.map(function (prop) {
        return URI__defineProperty({}, prop, self.store[prop]);
    })))));

    return self;
}

/**
 * @class URI
 * @classdesc URI parser with params manipulation
 *
 * @example const uri = new URI('website.com/page?param1=1');
 * uri.host;     // 'website.com'
 * uri.pathname; // '/page'
 * uri.params;   // {param1: '1'}
 * uri.params;   // {param1: '1', param2: '2'}
 */
var URI_URI = function () {
    /**
     * constructor
     * @param {String} href Full URI string
     */
    function URI(href) {
        URI__classCallCheck(this, URI);

        this[store] = Object.freeze({ href: href });
    }

    /**
     * a pointer to store property
     * @return {Object} store
     */


    URI__createClass(URI, [{
        key: 'toString',


        /**
         * Override native 'toString' function
         * @return {String} The full href string
         *
         * @example const uri = new URI('website.com/page?param1=1');
         * uri.toString(); // 'website.com/page?param1=1&param2=2'
         * '' + uri; // 'website.com/page?param1=1&param2=2'
         * `${uri}`; // 'website.com/page?param1=1&param2=2'
         */
        value: function toString() {
            return this.href;
        }

        /**
         * hasQueryParams
         * @return {Boolean} the query object has any members
         *
         * @example uri.hasQueryParams();
         */

    }, {
        key: 'hasQueryParams',
        value: function hasQueryParams() {
            return Object.keys(this.queryParams).length > 0;
        }

        /**
         * hasHashParams
         * @return {Boolean} the hash object has any members
         *
         * @example uri.hasHashParams();
         */

    }, {
        key: 'hasHashParams',
        value: function hasHashParams() {
            return Object.keys(this.hashParams).length > 0;
        }

        /**
         * add params to query or hash by interface
         * @param {Object} obj key value pairs
         * @param {String} mod which param set to address
         *
         * @example uri.addParams({key: 'value'});
         * uri.addParams({key: 'value'}, '?');
         */

    }, {
        key: 'addParams',
        value: function addParams(obj, mod) {
            this.params; // Should pre calculate

            var method = QUERY_TYPE_DICTIONARY[mod] || 'params';

            this[method] = obj;

            return this;
        }

        /**
         * @return {Boolean} Has any query or hash params
         *
         * @example uri.hasParams();
         */

    }, {
        key: 'hasParams',
        value: function hasParams() {
            return Object.keys(this.params).length > 0;
        }

        /**
         * remove params from query and hash
         * @param  {String[]} keys to remove
         * @return {Self}
         *
         * @example uri.removeParams('param_a', 'param_b');
         */

    }, {
        key: 'removeParams',
        value: function removeParams() {
            var _this = this;

            for (var _len2 = arguments.length, keys = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                keys[_key2] = arguments[_key2];
            }

            this.params; // Should pre calculate


            if (!keys.length) {

                // Remove all
                this[store] = Object.freeze(Object.assign.apply(Object, [{}, this.store, {
                    hashParams: {},
                    queryParams: {}
                }]));
            } else {
                this[store] = Object.freeze(Object.assign.apply(Object, URI__toConsumableArray([{}, this.store].concat(['hashParams', 'queryParams'].map(function (prop) {
                    return URI__defineProperty({}, prop, select_select(_this[prop], function (key) {
                        return !~keys.indexOf(key);
                    }));
                })))));
            }

            return _rebuild(this, 'queryParams', 'hashParams');
        }
    }, {
        key: 'store',
        get: function get() {
            return this[store];
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'href',
        get: function get() {
            return this.store.href;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'path',
        get: function get() {
            var _this2 = this;

            return _assign(this, 'path', function () {
                return analyze.path(_this2.href);
            }).store.path;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'pathname',
        get: function get() {
            var _this3 = this;

            this.path; // Should pre calculate
            this.host; // Should pre calculate

            return _assign(this, 'pathname', function () {
                return analyze.pathname(_this3.path, _this3.host);
            }).store.pathname;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'host',
        get: function get() {
            var _this4 = this;

            this.path; // Should pre calculate

            return _assign(this, 'host', function () {
                return analyze.host(_this4.path);
            }).store.host;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'top',
        get: function get() {
            var _this5 = this;

            this.host; // Should pre calculate

            return _assign(this, 'top', function () {
                return analyze.top(_this5.host);
            }).store.top;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'protocol',
        get: function get() {
            var _this6 = this;

            this.path; // Should pre calculate

            return _assign(this, 'protocol', function () {
                return analyze.protocol(_this6.path);
            }).store.protocol;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'query',
        get: function get() {
            var _this7 = this;

            return _assign(this, 'query', function () {
                return analyze.query(_this7.href);
            }).store.query;
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'queryParams',
        get: function get() {
            var _this8 = this;

            this.query; // Should pre calculate

            return _assign(this, 'queryParams', function () {
                return Object.freeze(queryStringToObject_queryStringToObject(_this8.query));
            }).store.queryParams;
        },
        set: function set(obj) {
            var _this9 = this;

            this.queryParams; // Should pre calculate

            _rebuild(_assign(this, 'queryParams', function () {
                return Object.assign({}, _this9.queryParams, obj);
            }, true), 'queryParams');
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'hash',
        get: function get() {
            var _this10 = this;

            return _assign(this, 'hash', function () {
                return analyze.hash(_this10.href);
            }).store.hash;
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'hashParams',
        get: function get() {
            var _this11 = this;

            this.hash; // Should pre calculate

            return _assign(this, 'hashParams', function () {
                return Object.freeze(queryStringToObject_queryStringToObject(_this11.hash));
            }).store.hashParams;
        },
        set: function set(obj) {
            var _this12 = this;

            this.hashParams; // Should pre calculate

            _rebuild(_assign(this, 'hashParams', function () {
                return Object.assign({}, _this12.hashParams, obj);
            }, true), 'hashParams');
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'params',
        get: function get() {
            this.queryParams; // Should pre calculate
            this.hashParams; // Should pre calculate

            return Object.assign({}, this.queryParams, this.hashParams);
        },
        set: function set(obj) {
            this.params; // Should pre calculate

            var method = !this.hasQueryParams() && this.hasHashParams() ? 'hash' : 'query';

            this[method + 'Params'] = obj;
        }
    }]);

    return URI;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/index.mjs
/**
 * @namespace url
 * @since 2.0.0
 */








/**
 * url A collection of url related methods
 * @type     {Object}
 * @property {Function} formDataIterable @see <a href="identifiers.html#url-formdataiterable">formDataIterable</a>
 * @property {Function} queryStringToObject @see <a href="identifiers.html#url-querystringtoobject">queryStringToObject</a>
 * @property {Function} serializeObject @see <a href="identifiers.html#url-serializeobject">serializeObject</a>
 * @property {Function} serializeParams @see <a href="identifiers.html#url-serializeparams">serializeParams</a>
 * @property {Function} toQueryString @see <a href="identifiers.html#url-toquerystring">toQueryString</a>
 * @property {Class}    URI @see <a href="identifiers.html#url-uri">URI</a>
 */
var url = {
    formDataIterable: formDataIterable,
    queryStringToObject: queryStringToObject_queryStringToObject,
    serializeObject: serializeObject,
    serializeParams: serializeParams,
    toQueryString: toQueryString,
    URI: URI_URI
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/index.mjs
/**
 * @module futile
 * @description This is the gateway to all exposed interfaces in the package
 * @since 2.0.0
 */





















// CONCATENATED MODULE: ./node_modules/@fiverr-private/pathfinder/src/index.js

var routeParamRegex = /\(?([^(]?):(\w+)\)?/g;
var PATHFINDER_ERROR = '[pathFinder]:';
var FIVERR_FQDN = 'https://www.fiverr.com';
var ROOT = '/';
var DEV_PREFIX = '__dev__';

/**
 * Fills in params in routes from route.rb
 * @param {String} namedRoute route for resolution
 * @param {Object} [userParams] Contains the user params to inject in the route
 * @param {Boolean} [useFQDN = false] When set to true, output will be prefixed with Fiverr's FQDN
 */
function pathFinder(namedRoute) {
    var userParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var useFQDN = arguments[2];


    if (!namedRoute || typeof namedRoute !== 'string') {
        throw new Error(PATHFINDER_ERROR + ' route missing');
    }

    if (namedRoute.indexOf(DEV_PREFIX) === 0) {
        console.warn(PATHFINDER_ERROR, 'Using dev only route. Make sure to replace it before going live.');
        return ROOT;
    }

    var output = void 0;

    try {
        output = fiverrRoutes[namedRoute];
    } catch (error) {
        if (env_env.prod) {
            return ROOT;
        }

        throw new Error(PATHFINDER_ERROR + ' missing global routes object');
    }

    var missingRequired = [];

    output = output.replace(routeParamRegex, function (match, prefix, name) {
        var param = userParams[name];

        if (param) {
            return '' + prefix + param;
        }

        if (match[0] !== '(') {
            missingRequired.push(name);
        }

        return '';
    });

    if (missingRequired.length) {
        throw new Error(PATHFINDER_ERROR + ' required params missing:\n' + missingRequired.join(',\n'));
    }

    return useFQDN ? FIVERR_FQDN + output : output;
}
// EXTERNAL MODULE: ./node_modules/@fiverr/modal/dist/index.js
var dist = __webpack_require__("5CFU");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/components/Title/index.scss
var components_Title = __webpack_require__("Nv6r");
var Title_default = /*#__PURE__*/__webpack_require__.n(components_Title);

// CONCATENATED MODULE: ./src/components/Title/index.js





var Title_Title = function Title(_ref) {
    var title = _ref.title;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'h2',
        { className: 'sharing-title' },
        title
    );
};

Title_Title.propTypes = {
    title: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
};

/* harmony default export */ var src_components_Title = (Title_Title);
// EXTERNAL MODULE: ./src/components/Description/index.scss
var components_Description = __webpack_require__("dHXs");
var Description_default = /*#__PURE__*/__webpack_require__.n(components_Description);

// CONCATENATED MODULE: ./src/components/Description/index.js





var Description_Description = function Description(_ref) {
    var description = _ref.description;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'sharing-description' },
        description.map(function (item, index) {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'p',
                { key: index },
                item
            );
        })
    );
};

Description_Description.propTypes = {
    description: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array.isRequired
};

/* harmony default export */ var src_components_Description = (Description_Description);
// EXTERNAL MODULE: external {"commonjs":"classnames","commonjs2":"classnames","amd":"classnames","root":"classNames","var":"classNames"}
var external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames__ = __webpack_require__("JgyH");
var external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames__);

// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Facebook.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Facebook_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        _extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-187 -369)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(13)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#3E5A99", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { className: "image-filter", fillOpacity: "0.2", fill: "#000", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M36.0548085,23.6101303 L31.1603782,23.6101303 L31.1603782,20.6914819 C31.1603782,19.5844084 31.9761166,19.2824792 32.485953,19.2824792 L35.9528412,19.2824792 L35.9528412,14.4516129 L31.1603782,14.4516129 C25.8580786,14.4516129 24.7364383,18.0747626 24.7364383,20.3895528 L24.7364383,23.6101303 L21.6774194,23.6101303 L21.6774194,28.6422827 L24.7364383,28.6422827 L24.7364383,42.7323095 L31.1603782,42.7323095 L31.1603782,28.6422827 L35.4430047,28.6422827 L36.0548085,23.6101303 Z",
                                fill: "#FFF" })
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Facebook = (Facebook_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Twitter.js
var Twitter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Twitter_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        Twitter__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-280 -369)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(106)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#60A9DD", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { className: "image-filter", fillOpacity: "0.2", fill: "#000", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M42.1262216,19.1290952 C41.1407756,19.6357476 39.9910886,19.9735159 38.8414016,20.057958 C39.9910886,19.2979793 40.8944141,18.1157902 41.3050166,16.6802749 C40.2374501,17.3558115 39.0056426,17.862464 37.6917146,18.2002323 C36.6241481,17.0180432 35.1459791,16.2580645 33.5035691,16.2580645 C30.38299,16.2580645 27.8372545,18.960211 27.8372545,22.3378941 C27.8372545,22.8445466 27.919375,23.266757 28.0014955,23.6889674 C23.2385065,23.4356411 19.0503609,20.9868209 16.2582639,17.3558115 C15.7655409,18.2846744 15.5191794,19.2979793 15.5191794,20.3957263 C15.5191794,22.5067783 16.5046254,24.364504 18.0649149,25.462251 C17.1615894,25.462251 16.2582639,25.1244827 15.5191794,24.7022723 L15.5191794,24.7867144 C15.5191794,27.7421871 17.4900714,30.1918518 20.1179274,30.7821019 C19.6252044,30.950986 19.1324814,31.0362725 18.6397584,31.0362725 C18.3112764,31.0362725 17.9006739,31.0362725 17.5721919,30.950986 C18.3112764,33.3998063 20.364289,35.1730899 22.9100245,35.1730899 C20.9391325,36.7774894 18.4755174,37.7916388 15.8476614,37.7916388 C15.3549384,37.7916388 14.9443359,37.7916388 14.4516129,37.7063523 C16.9973484,39.3951938 19.9536864,40.4084988 23.156386,40.4084988 C33.6678101,40.4084988 39.3341246,31.1198702 39.3341246,23.0978728 L39.3341246,22.3378941 C40.4016911,21.4090313 41.3871371,20.3957263 42.1262216,19.1290952",
                                fill: "#FFF" })
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Twitter = (Twitter_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/CopyLink.js
var CopyLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var CopyLink_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        CopyLink__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-373 -556)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 260)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(199 107)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                "g",
                                { className: "circle-wrapper", fill: "#FFF", stroke: "#CCC" },
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { className: "background-circle", cx: "28", cy: "28", r: "27.5", fillOpacity: "0", fill: "#000" })
                            ),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { className: "inner-image", d: "M28.121892,24.7230821 C28.7203205,24.1246416 29.6823291,24.1176829 30.2824972,24.7161235 C30.8757068,25.3093451 30.8861445,26.2644145 30.2737991,26.8750326 L25.8795248,31.2711352 C25.2810963,31.8695757 24.3190877,31.8765344 23.7206592,31.2780938 C23.1257099,30.6831325 23.1152722,29.7298028 23.7276177,29.117445 L28.121892,24.7230821 Z M32.3996119,31.2085077 L30.2477048,29.0565572 L35.7014063,23.6010061 C36.2006766,23.1017257 35.9188585,21.6125829 34.6524169,20.3461157 C33.3946732,19.0883468 31.8916436,18.801304 31.402811,19.2901465 L25.942151,24.7509166 L23.7902439,22.5972264 L29.2491643,17.138196 C31.1766607,15.2106607 34.5341228,15.8508529 36.8408559,18.1593722 C39.1562871,20.47485 39.7877683,23.8202023 37.855053,25.7546962 L32.3996119,31.2085077 Z M28.0557865,31.24678 L30.2076936,33.4004702 L24.7539921,38.8542817 C22.8212768,40.7887756 19.4742524,40.1555419 17.1588212,37.8400641 C14.8520881,35.5332845 14.2101692,32.1774943 16.1376656,30.249959 L21.5983256,24.7891889 L23.7502327,26.9428791 L18.2895727,32.4036491 C17.8007401,32.8924916 18.0877771,34.3955516 19.3455207,35.6533205 C20.6119624,36.9197878 22.1028147,37.2016115 22.602085,36.7023312 L28.0557865,31.24678 Z",
                                fill: "#999" })
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var CopyLink = (CopyLink_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Whatsapp.js
var Whatsapp__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Whatsapp_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        Whatsapp__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-466 -369)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { id: "Whatsapp-hover", transform: "translate(292)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#0D9F16", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { className: "image-filter", fillOpacity: "0.2", fill: "#000", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                "g",
                                { transform: "translate(13 12)" },
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M17.642644,28.0096291 C16.9446524,28.1278206 16.2430562,28.1906038 15.8734156,28.182968 C13.1552465,28.1749406 10.9390414,27.5685806 8.90103721,26.3405891 C8.64032262,26.1829785 8.41277082,26.1434291 8.10827611,26.2224627 C6.73831205,26.6002059 5.35851712,26.9388564 3.98645581,27.3009364 C3.69782156,27.3876059 3.67029514,27.3246922 3.74356786,27.0646838 C4.10711332,25.7656859 4.44922748,24.4743891 4.82496321,23.1907933 C4.92943256,22.8287133 4.8921408,22.5530417 4.68444736,22.2300543 C1.86547907,17.7184122 1.98410486,12.0965133 5.13909218,7.92306484 C8.41676871,3.57673432 12.8726419,1.79720379 18.2041831,2.93089011 C23.4583882,4.03351116 26.8073712,7.41107537 28.0389167,12.6161385 C29.7211091,19.7341954 24.8697074,26.8127027 17.642644,28.0096291 M30.5651873,11.8836248 C28.8668723,4.86803116 22.8061429,0.0826101053 15.4799188,-1.30526316e-05 C14.5151175,0.0157153684 13.5050288,0.0942922105 12.5066715,0.303134316 C2.28650233,2.36401432 -3.00938562,13.6474269 1.97230782,22.7577722 C2.1006334,23.0017259 2.11079197,23.1988206 2.03955095,23.4508017 C1.37721268,25.8523554 0.720904017,28.2539091 0.060597463,30.6474354 C-0.0462312896,31.0412985 -0.0462312896,31.0412985 0.349297252,30.9389659 C2.85007315,30.2854206 5.34678562,29.6395764 7.84559535,28.9783954 C8.05283002,28.9231827 8.2151704,28.9465469 8.40464397,29.0413091 C11.6232698,30.6788922 15.0135425,31.1594901 18.5636651,30.4745533 C27.0461958,28.8365133 32.5894939,20.2457933 30.5651873,11.8836248",
                                    fill: "#FCFCFC" }),
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M19.5243964,22.7735333 C18.9730159,22.7972891 18.44713,22.6711354 17.9191469,22.5292533 C14.3709905,21.513628 11.7082674,19.3012069 9.56900529,16.3875985 C8.7605148,15.2930701 8.01153383,14.1593838 7.76255074,12.7971459 C7.46382347,11.1591712 7.93629493,9.77356905 9.16010677,8.63949116 C9.54960571,8.28511221 10.7354049,8.12789326 11.209908,8.35605326 C11.3860116,8.442788 11.4986078,8.60039853 11.571815,8.76564484 C12.0204302,9.82878168 12.4633436,10.8757333 12.9021934,11.9388701 C12.9852315,12.1436659 12.9495782,12.3404343 12.8568404,12.5451648 C12.6313203,13.0333985 12.2694133,13.4268701 11.9018044,13.8127059 C11.6232632,14.0965354 11.6111385,14.3561522 11.8167347,14.6948027 C13.0701702,16.7734343 14.8038108,18.2852554 17.0713985,19.1907164 C17.4094493,19.3245712 17.6645275,19.2773859 17.8895888,18.9940133 C18.2673562,18.5295354 18.666555,18.0647312 19.0243985,17.5845901 C19.2693182,17.2459396 19.5503499,17.1987543 19.8960687,17.3559733 C20.6454429,17.6946238 21.3944239,18.0490027 22.1437981,18.4033817 C22.3118404,18.4743227 22.4777854,18.5609922 22.6438615,18.6396343 C23.4029355,19.0177691 23.3952674,19.0254048 23.3299905,19.8599248 C23.2033034,21.4898722 21.9757558,22.2933922 20.520722,22.6948912 C20.2004979,22.7811691 19.8604154,22.7892617 19.5243964,22.7735333",
                                    fill: "#FDFDFD" })
                            )
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Whatsapp = (Whatsapp_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/FbMessenger.js
var FbMessenger__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var FbMessenger_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        FbMessenger__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-559 -369)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(385)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#0084FF", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { className: "image-filter", fillOpacity: "0.2", fill: "#000",
                                xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M29.3913016,32.4567974 L25.8260944,28.6543287 L18.8695584,32.4567974 L26.5217424,24.3333333 L30.1739168,28.1358021 L37.0434856,24.3333333 L29.3913016,32.4567974 Z M28.0000056,15 C20.2679992,15 14,20.8036855 14,27.9629636 C14,32.0424196 16.0358252,35.6812115 19.2173936,38.0574044 L19.2173936,43 L23.9842637,40.3838246 C25.2564403,40.7358967 26.6041793,40.9259384 28.0000056,40.9259384 C35.7320121,40.9259384 42,35.1222416 42,27.9629636 C42,20.8036855 35.7320121,15 28.0000056,15 Z",
                                fill: "#FFF" })
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var FbMessenger = (FbMessenger_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Linkedin.js
var Linkedin__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Linkedin_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        Linkedin__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-373.000000, -369.000000)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120.000000, 189.000000)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54.000000, 180.000000)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(199.000000, 0.000000)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#0677B5", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { className: "image-filter", fillOpacity: "0.1", fill: "#000000", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                "g",
                                { transform: "translate(14.451613, 14.451613)", fill: "#FFFFFF" },
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("polygon", { id: "Fill-3", points: "0.341578453 27.0700924 6.14841215 27.0700924 6.14841215 8.79564516 0.341578453 8.79564516" }),
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M3.24482451,6.31920138 C1.28074841,6.31920138 -0.000170789226,4.95288757 -0.000170789226,3.15960069 C-0.000170789226,1.36631381 1.28074841,-3.55271368e-15 3.24482451,-3.55271368e-15 C5.20890062,-3.55271368e-15 6.4044252,1.36631381 6.48981981,3.15960069 C6.57521443,4.86749295 5.29429523,6.31920138 3.24482451,6.31920138", id: "Fill-5" }),
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M27.0702632,26.9848686 L21.2634295,26.9848686 L21.2634295,17.2498827 C21.2634295,14.7734389 20.4094833,13.1509412 18.3600126,13.1509412 C16.736661,13.1509412 15.7981742,14.2610712 15.3712012,15.3703472 C15.2004119,15.7973203 15.2004119,16.3105419 15.2004119,16.8229096 L15.2004119,26.9848686 L9.39357824,26.9848686 C9.39357824,26.9848686 9.47811891,10.5037082 9.39357824,8.71042134 L15.2004119,8.71042134 L15.2004119,11.2722597 C15.9689635,9.99134053 17.3352773,8.28344827 20.4094833,8.28344827 C24.2522409,8.28344827 27.0702632,10.9306813 27.0702632,16.4813311 L27.0702632,26.9848686 Z", id: "Fill-6" })
                            )
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Linkedin = (Linkedin_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Embed.js
var Embed__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Embed_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        Embed__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "defs",
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { id: "path-1", cx: "28", cy: "28", r: "28" }),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("polygon", { id: "path-2", points: "0.0467185917 0.00835294118 8.28123192 0.00835294118 8.28123192 15 0.0467185917 15" }),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("polygon", { id: "path-4", points: "0.0637253469 0.0376764706 8.32783505 0.0376764706 8.32783505 14.9582992 0.0637253469 14.9582992" })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-466 -476)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(292 107)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { fill: "#FFF", xlinkHref: "#path-1" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { className: "background-circle", stroke: "#CCC", strokeLinejoin: "square", fillOpacity: "0",
                                fill: "#000", cx: "28", cy: "28", r: "27.5" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                "g",
                                { transform: "translate(14 21)" },
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                    "g",
                                    { transform: "translate(9.814)" },
                                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                        "mask",
                                        { id: "mask-3", fill: "#fff" },
                                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { xlinkHref: "#path-2" })
                                    ),
                                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M1.04644948,14.8612941 C1.88356289,15.2436471 2.89387216,14.8024706 3.2691299,13.9492353 L8.14748041,2.42011765 C8.32067629,2.00835294 8.32067629,1.53776471 8.17634639,1.09658824 C8.00315052,0.655411765 7.68562474,0.331882353 7.28150103,0.155411765 C7.07915052,0.0671764706 6.84851134,0.00835294118 6.61758351,0.00835294118 C5.95366598,0.00835294118 5.34719175,0.419823529 5.05853196,1.03776471 L0.180470103,12.5965882 C0.0072742268,13.0080588 0.0072742268,13.4789412 0.151604124,13.9201176 C0.3248,14.3315882 0.642325773,14.6554118 1.04644948,14.8612941",
                                        id: "Fill-1", fill: "#999", mask: "url(#mask-3)" })
                                ),
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                    "g",
                                    { transform: "translate(19.629)" },
                                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                        "mask",
                                        { id: "mask-5", fill: "#fff" },
                                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("use", { xlinkHref: "#path-4" })
                                    ),
                                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M3.03802887,0.625911765 C2.72050309,0.243558824 2.25893608,0.0376764706 1.76821443,0.0376764706 C1.36380206,0.0376764706 0.95996701,0.184735294 0.671307216,0.449441176 C0.324915464,0.743558824 0.122564948,1.15532353 0.0939876289,1.62591176 C0.0648329897,2.0965 0.209162887,2.53767647 0.49782268,2.86120588 L4.3947299,7.50826471 L0.469245361,12.1553235 C-0.137228866,12.8612059 -0.050342268,13.9494412 0.642152577,14.5670882 C1.33522474,15.1553235 2.4318433,15.0670882 3.00916289,14.3906176 L7.91637938,8.62591176 C8.46512165,7.97885294 8.46512165,7.03767647 7.91637938,6.39061765 L3.03802887,0.625911765 Z",
                                        fill: "#999", mask: "url(#mask-5)" })
                                ),
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M7.68556701,14.5294118 C8.37835052,13.9114706 8.46494845,12.8232353 7.85876289,12.1176471 L3.93298969,7.47058824 L7.85876289,2.82352941 C8.14742268,2.47058824 8.29175258,2.02941176 8.2628866,1.58823529 C8.23402062,1.11735294 8.03195876,0.705882353 7.68556701,0.411764706 C7.36804124,0.147058824 6.99278351,0 6.58865979,0 C6.09793814,0 5.63608247,0.205882353 5.3185567,0.588235294 L0.411340206,6.35294118 C-0.137113402,6.99970588 -0.137113402,7.94117647 0.411340206,8.58823529 L5.28969072,14.3526471 C5.86701031,15.0291176 6.99278351,15.1176471 7.68556701,14.5294118",
                                    fill: "#999" })
                            )
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Embed = (Embed_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/Email.js
var Email__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Email_ImageJs = function ImageJs(props) {
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        "svg",
        Email__extends({}, props, { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                "g",
                { transform: "translate(-280 -476)" },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    "g",
                    { transform: "translate(120 189)" },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        "g",
                        { transform: "translate(54 180)" },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            "g",
                            { transform: "translate(106 107)" },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("circle", { className: "background-circle", stroke: "#CCC", fillOpacity: "0", fill: "#000", cx: "28",
                                cy: "28", r: "27.5" }),
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement("path", { d: "M25.7926579,29.3288289 L19.2456336,34.7825164 L36.7543794,34.7825164 L30.2073605,29.3288335 L28.7481697,30.4856112 C28.3127315,30.8334503 27.6875523,30.8334503 27.2524118,30.4858481 L25.7926579,29.3288289 Z M38.7333344,22.542166 L32.0770356,27.8370883 L38.7333344,33.3868069 L38.7333344,22.542166 Z M17.2666786,22.5421609 L17.2666786,33.3868122 L23.9232445,27.8370883 L17.2666786,22.5421609 Z M19.3658943,21.2188732 L28.0000074,28.0878345 L36.6343827,21.2188732 L19.3658943,21.2188732 Z M15.9634681,18.9018828 L15.9683265,18.9015177 C16.0082608,18.8994941 16.0484725,18.8994941 16.0833458,18.9013896 L39.9166672,18.9013896 C40.5696588,18.9013896 41.1,19.4196923 41.1,20.0601314 L41.1,35.9412582 C41.1,36.5816026 40.5697661,37.0997111 39.9166672,37.1 L16.0833015,37.1 C15.4302469,37.0997111 14.900013,36.5816026 14.900013,35.9412582 L14.9000142,20.0606281 C14.8970473,19.4633236 15.3576716,18.962272 15.9634681,18.9018828 Z",
                                stroke: "#999", strokeWidth: "0.2", fill: "#999" })
                        )
                    )
                )
            )
        )
    );
};

/* harmony default export */ var Email = (Email_ImageJs);
// CONCATENATED MODULE: ./src/components/SocialMedium/assets/index.js










// CONCATENATED MODULE: ./src/components/SocialMedium/conf.js


var socialMediaConfiguration = {
    facebook: {
        reactComponent: Facebook,
        description: 'sharing_link.medium.facebook'
    },
    embed: {
        reactComponent: Embed,
        description: 'sharing_link.medium.embed'
    },
    copy_link: {
        reactComponent: CopyLink,
        description: 'sharing_link.medium.copy_link'
    },
    fb_messenger: {
        reactComponent: FbMessenger,
        description: 'sharing_link.medium.fb_messenger'
    },
    linkedin: {
        reactComponent: Linkedin,
        description: 'sharing_link.medium.linkedin'
    },
    twitter: {
        reactComponent: Twitter,
        description: 'sharing_link.medium.twitter'
    },
    whatsapp: {
        reactComponent: Whatsapp,
        description: 'sharing_link.medium.whatsapp'
    },
    email: {
        reactComponent: Email,
        description: 'sharing_link.medium.email'
    }
};
// EXTERNAL MODULE: ./src/components/SocialMedium/index.scss
var components_SocialMedium = __webpack_require__("Eout");
var SocialMedium_default = /*#__PURE__*/__webpack_require__.n(components_SocialMedium);

// CONCATENATED MODULE: ./src/components/SocialMedium/index.js






var SocialMedium_SocialMedium = function SocialMedium(_ref) {
    var socialMedium = _ref.socialMedium,
        onClick = _ref.onClick;

    var availableMedia = socialMediaConfiguration;
    var medium = socialMedium.medium,
        isLoading = socialMedium.isLoading,
        isVisited = socialMedium.isVisited;

    if (medium !== 'undefined' && Object.keys(availableMedia).indexOf(medium) === -1) {
        throw new TypeError('Social medium: social medium is not defined properly');
    }

    var socialMediumClasses = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()('social-medium', { 'is-loading': isLoading, 'is-visited': isVisited && medium === 'copy_link' }),
        image = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(availableMedia[medium].reactComponent, { className: 'social-medium-image' });
    var description = void 0;

    description = i18n.t(availableMedia[medium].description);

    if (isVisited && medium === 'copy_link') {
        description = i18n.t('sharing_link.medium.visited.copy_link');
    }

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'li',
        { className: socialMediumClasses, onClick: !isLoading && onClick },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            null,
            image
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'span',
            null,
            description
        )
    );
};

SocialMedium_SocialMedium.propTypes = {
    socialMedium: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        medium: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
        isLoading: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
        isVisited: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
    }).isRequired,
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

SocialMedium_SocialMedium.defaultProps = {
    socialMedium: {
        medium: '',
        isLoading: false,
        isVisited: false
    }
};

/* harmony default export */ var src_components_SocialMedium = (SocialMedium_SocialMedium);
// EXTERNAL MODULE: ./src/components/SocialMediumItems/index.scss
var components_SocialMediumItems = __webpack_require__("ETja");
var SocialMediumItems_default = /*#__PURE__*/__webpack_require__.n(components_SocialMediumItems);

// CONCATENATED MODULE: ./src/components/SocialMediumItems/index.js






var SocialMediumItems_SocialMediumItems = function SocialMediumItems(_ref) {
    var mediums = _ref.mediums,
        _onClick = _ref.onClick;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'ul',
        { className: 'social-mediums' },
        mediums.map(function (item, index) {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_SocialMedium, { key: index, socialMedium: item, onClick: function onClick() {
                    return _onClick(item.medium);
                } });
        })
    );
};

SocialMediumItems_SocialMediumItems.propTypes = {
    mediums: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.arrayOf(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        medium: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
        isVisited: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
        isLoading: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
    })).isRequired,
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var src_components_SocialMediumItems = (SocialMediumItems_SocialMediumItems);
// CONCATENATED MODULE: ./src/components/SocialMediaBody/index.js







var SocialMediaBody_SocialMediaBody = function SocialMediaBody(_ref) {
    var settings = _ref.settings,
        onClick = _ref.onClick,
        socialMediumItems = _ref.socialMediumItems;
    var title = settings.title,
        description = settings.description;


    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        null,
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_Title, { title: title }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_Description, { description: description }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_SocialMediumItems, { mediums: socialMediumItems, onClick: onClick })
    );
};

SocialMediaBody_SocialMediaBody.propTypes = {
    settings: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        title: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
        description: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array
    }).isRequired,
    socialMediumItems: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.arrayOf(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        medium: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
        isVisited: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
        isLoading: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
    })).isRequired,
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var components_SocialMediaBody = (SocialMediaBody_SocialMediaBody);
// EXTERNAL MODULE: ./src/components/CloseButton/index.scss
var components_CloseButton = __webpack_require__("wLjs");
var CloseButton_default = /*#__PURE__*/__webpack_require__.n(components_CloseButton);

// CONCATENATED MODULE: ./src/components/CloseButton/index.js





var CloseButton_CloseButton = function CloseButton(_ref) {
    var onClick = _ref.onClick;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'button',
        { className: 'close-button', onClick: onClick },
        '\xD7'
    );
};

CloseButton_CloseButton.propTypes = {
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var src_components_CloseButton = (CloseButton_CloseButton);
// EXTERNAL MODULE: ./node_modules/@fiverr/modal/dist/index.css
var modal_dist = __webpack_require__("0Qmd");
var modal_dist_default = /*#__PURE__*/__webpack_require__.n(modal_dist);

// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// CONCATENATED MODULE: ./src/utils/bigQueryReporter.js
var sendClientEvents = function sendClientEvents(type, reason, source) {
    var eventData = {
        type: type,
        group: 'share_on_social_network',
        reason: reason,
        current_page_type: source
    };

    if (typeof Fiverr !== 'undefined' && typeof Fiverr.sendClientEvents === 'function') {
        Fiverr.sendClientEvents(eventData);
    }
};

/* harmony default export */ var bigQueryReporter = (sendClientEvents);
// CONCATENATED MODULE: ./src/utils/graphiteReporter.js
var logEventToGraphite = function logEventToGraphite(_ref) {
    var label = _ref.label,
        _ref$percentage = _ref.percentage,
        percentage = _ref$percentage === undefined ? 100 : _ref$percentage;

    var eventData = {
        label: label,
        percentage: percentage
    };

    if (typeof Fiverr !== 'undefined' && typeof Fiverr._logEventToGraphite === 'function') {
        Fiverr._logEventToGraphite(eventData);
    }
};

/* harmony default export */ var graphiteReporter = (logEventToGraphite);
// CONCATENATED MODULE: ./src/utils/constants.js
var POPUP_CONFIG = 'height=300, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';
var REDIRECT_SHARE_URL = '/sharing/social_redirect';

var platforms = {
    FACEBOOK: 'facebook',
    WHATSAPP: 'whatsapp',
    FB_MESSANGER: 'fb_messanger',
    TWITTER: 'twitter',
    EMAIL: 'email',
    LINKEDIN: 'linkedin',
    COPY_LINK: 'copy_link',
    EMBED: 'embed'
};
// CONCATENATED MODULE: ./src/utils/redirectShareLink.js


var redirectShareLink_redirectShareLink = function redirectShareLink(medium, linkOptions, shareText) {
    var source = linkOptions.source,
        resource_type = linkOptions.resource_type,
        resource_id = linkOptions.resource_id,
        is_resource_owner = linkOptions.is_resource_owner;

    var text = '&share_text=' + (shareText ? encodeURIComponent(shareText) : '');

    return REDIRECT_SHARE_URL + '?source=' + source + '&medium=' + medium + '&resource_type=' + resource_type + '&resource_id=' + resource_id + '&is_resource_owner=' + is_resource_owner + text;
};
// CONCATENATED MODULE: ./src/utils/copyLink.js


var copyLink_copyLink = function copyLink(shareLink) {
    if (!shareLink) {
        throw new SyntaxError('Share link is missing!');
    }
    if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(shareLink);
    } else if (document) {
        var input = document.createElement('input');
        input.style.position = 'fixed';
        input.style.top = '-100vh';

        document.body.appendChild(input);
        input.value = shareLink;
        input.focus();
        input.select();

        var result = document.execCommand('copy');
        if (!result) {
            graphiteReporter({ label: 'social_sharing.error.copy_link' });
        }

        document.body.removeChild(input);
    } else {
        throw new Error('Copying is not supported without either navigator or document');
    }
};
// EXTERNAL MODULE: ./src/components/EmailInput/index.scss
var components_EmailInput = __webpack_require__("Ojd5");
var EmailInput_default = /*#__PURE__*/__webpack_require__.n(components_EmailInput);

// CONCATENATED MODULE: ./src/components/EmailInput/index.js





var EmailInput_EmailInput = function EmailInput(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { className: 'email-input', type: 'email', name: 'share-email', autoComplete: 'off', onChange: onChange, value: value,
        placeholder: i18n.t('sharing_link.invite.input') });
};

EmailInput_EmailInput.propTypes = {
    onChange: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired,
    value: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};
// EXTERNAL MODULE: ./src/components/LargeButton/index.scss
var components_LargeButton = __webpack_require__("NPIf");
var LargeButton_default = /*#__PURE__*/__webpack_require__.n(components_LargeButton);

// CONCATENATED MODULE: ./src/components/LargeButton/index.js
var LargeButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LargeButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LargeButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LargeButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var buttons = function buttons() {
    return {
        SHARE: i18n.t('general.share'),
        SEND: i18n.t('sharing_link.button.send')
    };
};

var LargeButton_LargeButton = function (_PureComponent) {
    LargeButton__inherits(LargeButton, _PureComponent);

    function LargeButton(props) {
        LargeButton__classCallCheck(this, LargeButton);

        var _this = LargeButton__possibleConstructorReturn(this, (LargeButton.__proto__ || Object.getPrototypeOf(LargeButton)).call(this, props));

        i18n.add(translations_en_default.a);
        return _this;
    }

    LargeButton__createClass(LargeButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                onClick = _props.onClick,
                children = _props.children,
                className = _props.className;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'button',
                { className: external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()('sharing-link-button btn-lrg-standard', className), onClick: onClick },
                children
            );
        }
    }]);

    return LargeButton;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

LargeButton_LargeButton.propTypes = {
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var src_components_LargeButton = (LargeButton_LargeButton);
// EXTERNAL MODULE: ./src/components/EmailBody/index.scss
var components_EmailBody = __webpack_require__("KRU7");
var EmailBody_default = /*#__PURE__*/__webpack_require__.n(components_EmailBody);

// CONCATENATED MODULE: ./src/components/EmailBody/index.js
var EmailBody__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function EmailBody__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EmailBody__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EmailBody__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EmailBody_EmailBody = function (_PureComponent) {
    EmailBody__inherits(EmailBody, _PureComponent);

    EmailBody__createClass(EmailBody, null, [{
        key: 'boundFunctions',
        get: function get() {
            return ['onInputChange', 'onMailSubmit'];
        }
    }]);

    function EmailBody(props) {
        EmailBody__classCallCheck(this, EmailBody);

        var _this = EmailBody__possibleConstructorReturn(this, (EmailBody.__proto__ || Object.getPrototypeOf(EmailBody)).call(this, props));

        _this.state = {
            emailInput: ''
        };

        _this.constructor.boundFunctions.forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
        return _this;
    }

    EmailBody__createClass(EmailBody, [{
        key: 'onInputChange',
        value: function onInputChange(e) {
            this.setState({
                emailInput: e.target.value
            });
        }
    }, {
        key: 'onMailSubmit',
        value: function onMailSubmit() {
            this.props.onSendMail(this.state.emailInput);
        }
    }, {
        key: 'render',
        value: function render() {
            var emailTitle = this.props.emailTitle;
            var emailInput = this.state.emailInput;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'email-body' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_Title, { title: emailTitle }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'form',
                    null,
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'label',
                        { htmlFor: 'share-email' },
                        i18n.t('sharing_link.invite.send_to')
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(EmailInput_EmailInput, { onChange: this.onInputChange, value: emailInput }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        src_components_LargeButton,
                        { onClick: this.onMailSubmit },
                        i18n.t('sharing_link.button.send')
                    )
                )
            );
        }
    }]);

    return EmailBody;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

EmailBody_EmailBody.propTypes = {
    emailTitle: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
    onSendMail: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var src_components_EmailBody = (EmailBody_EmailBody);
// EXTERNAL MODULE: ./src/components/BackButton/index.scss
var components_BackButton = __webpack_require__("Z45/");
var BackButton_default = /*#__PURE__*/__webpack_require__.n(components_BackButton);

// CONCATENATED MODULE: ./src/components/BackButton/index.js





var BackButton_BackButton = function BackButton(_ref) {
    var onClick = _ref.onClick;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('button', { className: 'back-button', onClick: onClick });
};

BackButton_BackButton.propTypes = {
    onClick: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func.isRequired
};

/* harmony default export */ var src_components_BackButton = (BackButton_BackButton);
// CONCATENATED MODULE: ./src/utils/mixPanelReporter.js
var mixpanelTrackEvent = function mixpanelTrackEvent(media, asset) {
    var eventObject = {
        Media: media,
        'Shared Asset': asset
    };

    if (typeof MixpanelWrapper !== 'undefined' && typeof MixpanelWrapper.trackEvent === 'function') {
        MixpanelWrapper.trackEvent('Clicked Social Sharing', eventObject);
    }
};

/* harmony default export */ var mixPanelReporter = (mixpanelTrackEvent);
// EXTERNAL MODULE: ./src/index.scss
var src = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/SharingLink.js
var SharingLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SharingLink__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var SharingLink__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SharingLink__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SharingLink__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SharingLink__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var SharingLink_SharingLink = function (_PureComponent) {
    SharingLink__inherits(SharingLink, _PureComponent);

    SharingLink__createClass(SharingLink, null, [{
        key: 'boundFunctions',
        get: function get() {
            return ['onShareEventCalled', 'openModal', 'onClose', 'onSocialMediumClick', 'fetchLink', 'setShareable', 'resetMediaState', 'closeModal', 'finaliseShare', 'setPropertiesOnMedium', 'getSourceTranslationKey', 'onModalOpen', 'findSocialMedium', 'defineCopyLink', 'onModalClose', 'onSendMail', 'onBack'];
        }
    }]);

    function SharingLink(props) {
        SharingLink__classCallCheck(this, SharingLink);

        var _this = SharingLink__possibleConstructorReturn(this, (SharingLink.__proto__ || Object.getPrototypeOf(SharingLink)).call(this, props));

        _this.constructor.boundFunctions.forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
        _this._modalInterface = {};

        _this.state = {
            translationKey: '', // current translation path for this source
            socialMedia: [], // stores Social platforms visual state
            settings: { // stores Modal settings
                title: '',
                description: [],
                email_title: ''
            },
            shareable: null, // the object to share (gig / delivery / user)
            isLoading: true,
            showMail: false
        };
        return _this;
    }

    SharingLink__createClass(SharingLink, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
                i18n.add(translations_en_default.a);
                window.addEventListener('open-share-modal', this.onShareEventCalled, false);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('open-share-modal', this.onShareEventCalled, false);
        }
    }, {
        key: 'onShareEventCalled',
        value: function onShareEventCalled(e) {
            if (this.isValidSource(e.detail)) {
                sendClientEvents('social_share.button.click');
                this.setShareable(e.detail, true);
                return;
            }

            throw new Error('Please make sure all the required fields are present.');
        }
    }, {
        key: 'isValidSource',
        value: function isValidSource(data) {
            if ((typeof data === 'undefined' ? 'undefined' : SharingLink__typeof(data)) !== 'object') {
                return false;
            }

            return data.hasOwnProperty('source') && data.hasOwnProperty('resource_type') && data.hasOwnProperty('resource_id') && data.hasOwnProperty('is_resource_owner');
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this._modalInterface.close();
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            this.setState({
                showMail: false
            });
        }
    }, {
        key: 'onModalOpen',
        value: function onModalOpen() {
            var copyLinkMedium = this.findSocialMedium(platforms.COPY_LINK);
            if (copyLinkMedium && !copyLinkMedium.link) {
                this.fetchLink(platforms.COPY_LINK, this.defineCopyLink);
            }
        }
    }, {
        key: 'onModalClose',
        value: function onModalClose() {
            this.resetMediaState();
        }
    }, {
        key: 'onSendMail',
        value: function onSendMail() {
            this.onBack();
        }
    }, {
        key: 'defineCopyLink',
        value: function defineCopyLink(medium, shareLink) {
            this.setPropertiesOnMedium(platforms.COPY_LINK, { isLoading: false, isVisited: false, link: shareLink });
        }
    }, {
        key: 'findSocialMedium',
        value: function findSocialMedium(medium) {
            return this.state.socialMedia.find(function (item) {
                return item.medium === medium;
            });
        }
    }, {
        key: 'onSocialMediumClick',
        value: function onSocialMediumClick(medium) {
            var _state = this.state,
                translationKey = _state.translationKey,
                shareable = _state.shareable,
                vars = _.result(shareable, 'interpolation_variables', {}),
                shareText = i18n.t(translationKey + '.share_texts.' + medium) !== medium ? i18n.t(translationKey + '.share_texts.' + medium, vars) : i18n.t(translationKey + '.share_texts.default', vars);

            sendClientEvents('social_share.click', medium);
            mixPanelReporter(medium, this.state.shareable.resource_type);
            this.setPropertiesOnMedium(medium, { isVisited: true });

            switch (medium) {
                case platforms.COPY_LINK:
                    copyLink_copyLink(this.findSocialMedium(platforms.COPY_LINK).link);
                    this.finaliseShare(medium);
                    break;
                case platforms.EMAIL:
                    this.setState({
                        showMail: true
                    });
                    break;
                case platforms.WHATSAPP:
                    window.open(redirectShareLink_redirectShareLink(medium, shareable, shareText), '_blank');
                    this.finaliseShare(medium);
                    break;
                default:
                    window.open(redirectShareLink_redirectShareLink(medium, shareable, shareText), 'sharepopup', POPUP_CONFIG);
                    this.finaliseShare(medium);
                    break;
            }
        }
    }, {
        key: 'setShareable',
        value: function setShareable(shareable) {
            var _this2 = this;

            var openAfterSetup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (JSON.stringify(shareable) === JSON.stringify(this.state.shareable)) {
                // check if the same item clicked again
                this.openModal();
                return;
            }

            var source = shareable.source,
                interpolation_variables = shareable.interpolation_variables,
                translationKey = this.getSourceTranslationKey(source),
                newSocialMedia = i18n.t(translationKey + '.mediums').map(function (medium) {
                return Object.assign({}, { medium: medium, isLoading: false });
            }),
                settings = this.state.settings;

            var _loop = function _loop(settingKey) {
                if (Array.isArray(i18n.t(translationKey + '.' + settingKey))) {
                    settings[settingKey] = Object.keys(i18n.t(translationKey + '.' + settingKey)).map(function (key) {
                        return i18n.t(translationKey + '.' + settingKey + '.' + key, interpolation_variables);
                    });
                } else {
                    settings[settingKey] = i18n.t(translationKey + '.' + settingKey, interpolation_variables);
                }
            };

            for (var settingKey in settings) {
                _loop(settingKey);
            }

            this.setState({
                translationKey: translationKey,
                shareable: shareable,
                settings: settings,
                socialMedia: newSocialMedia,
                isLoading: false
            }, function () {
                return openAfterSetup ? _this2.openModal() : null;
            });
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this3 = this;

            if (this._modalInterface && typeof this._modalInterface.open === 'function') {

                this._modalInterface.shouldPreventCloseAction = function () {
                    return true;
                };

                /**
                 * The "shouldPreventCloseAction" function is part of the toggler.
                 * once this function returns false, the modal will not close.
                 * Our issue happens once we trigger the custom event through an outside click event,
                 * this event will cause the modal to close itself immediately, therefore, setting the
                 * "shouldPreventCloseAction" to false until the end of the event loop fixes that problem.
                */
                setTimeout(function () {
                    return _this3._modalInterface.shouldPreventCloseAction = function () {
                        return false;
                    };
                });

                this._modalInterface.open();
            }
        }
    }, {
        key: 'getSourceTranslationKey',
        value: function getSourceTranslationKey(source) {
            var ab_tests = this.props.ab_tests;

            // get the default settings if
            // nothing else available

            if (source in translations_en_default.a.sources) {
                // check if we have any A/B tests running
                var sourceTestKey = Object.keys(translations_en_default.a.sources[source]).find(function (sourceKey) {
                    return sourceKey !== 'default';
                });

                if (sourceTestKey && ab_tests && (typeof ab_tests === 'undefined' ? 'undefined' : SharingLink__typeof(ab_tests)) === 'object') {
                    var transTestKey = 'sources.' + source + '.' + sourceTestKey + '.' + ab_tests[sourceTestKey];

                    if (SharingLink__typeof(translations_en_default.a.sources[source][sourceTestKey][ab_tests[sourceTestKey]]) === 'object') {
                        return transTestKey;
                    }
                }

                // Get the default source settings
                return 'sources.' + source + '.default';
            } else {
                return 'sources.defaults';
            }
        }
    }, {
        key: 'fetchLink',
        value: function fetchLink(medium, callback) {
            var _state$shareable = this.state.shareable,
                source = _state$shareable.source,
                resource_type = _state$shareable.resource_type,
                resource_id = _state$shareable.resource_id,
                is_resource_owner = _state$shareable.is_resource_owner;


            this.setPropertiesOnMedium(medium, { isLoading: true });

            var requestBody = {
                medium: medium,
                resource_type: resource_type,
                resource_id: resource_id,
                is_resource_owner: is_resource_owner
            };

            if (source) {
                requestBody.source = source;
            }

            gofor(pathFinder('sharing_generate_link'), {
                method: 'POST',
                body: JSON.stringify(requestBody)
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response) {
                    safe(callback(medium, response.link));
                }
            }).catch(function (err) {
                logEventToGraphite({ label: 'social_share.generate_link.error' });
                throw err;
            });
        }
    }, {
        key: 'finaliseShare',
        value: function finaliseShare(medium) {
            var _this4 = this;

            if (medium !== platforms.COPY_LINK) {
                this.closeModal();
            } else {
                setTimeout(function () {
                    return _this4.closeModal();
                }, 3000);
            }
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            if (typeof this._modalInterface.close === 'function') {
                this._modalInterface.close();
            }
        }
    }, {
        key: 'setPropertiesOnMedium',
        value: function setPropertiesOnMedium(medium, properties) {
            var newSocialMedia = this.state.socialMedia.map(function (socialMedium) {
                if (socialMedium.medium === medium) {
                    Object.assign(socialMedium, SharingLink__extends({}, properties));
                }
                return socialMedium;
            });

            this.setState({
                socialMedia: newSocialMedia
            });
        }
    }, {
        key: 'resetMediaState',
        value: function resetMediaState() {
            var newSocialMedia = this.state.socialMedia.map(function (item) {
                return Object.assign({}, SharingLink__extends({}, item, { isLoading: false, isVisited: false }));
            });

            this.setState({
                socialMedia: newSocialMedia,
                showMail: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state2 = this.state,
                settings = _state2.settings,
                socialMedia = _state2.socialMedia,
                showMail = _state2.showMail;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist_default.a,
                { ref: function ref(_ref2) {
                        return _this5._modalInterface = _ref2;
                    }, onOpen: this.onModalOpen, onClose: this.onModalClose },
                function (_ref) {
                    var preventCloseAction = _ref.preventCloseAction;
                    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'sharing-link', ref: preventCloseAction },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_CloseButton, { onClick: _this5.onClose }),
                        showMail && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_BackButton, { onClick: _this5.onBack }),
                        showMail ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_components_EmailBody, { emailTitle: settings.email_title, onSendMail: _this5.onSendMail }) : external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(components_SocialMediaBody, { settings: settings, socialMediumItems: socialMedia,
                            onClick: _this5.onSocialMediumClick })
                    );
                }
            );
        }
    }]);

    return SharingLink;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

SharingLink_SharingLink.PropTypes = {
    ab_tests: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object
};

SharingLink_SharingLink.defaultProps = {
    ab_tests: null
};

/* harmony default export */ var src_SharingLink = (SharingLink_SharingLink);
// CONCATENATED MODULE: ./src/index.js




var componentElm = typeof document !== 'undefined' && document.getElementById('SharingLink-component');

if (componentElm) {
    var initialState = window.initialData.SharingLink;

    external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.render(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_SharingLink, initialState), componentElm);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = (src_SharingLink);

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ }),

/***/ "wLjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.493b8354bd28bf62d23e.js